/* eslint-disable quotes */

/* eslint-disable max-len */

/* eslint-disable object-curly-newline */
import { ISelectData } from 'components/atoms/SelectComponent';

export const leiRejstrikyPermanent: ISelectData[] = [
    {
        labelcz: 'LEI_REJSTRIK_INY',
        labelen: 'LEI_REJSTRIK_INY',
        value: 'RA888888'
    }
];
export const leiRejstrikySelect = {
    EU: [],
    XX: [],
    UN: [],
    AF: [
        {
            value: 'RA000001',
            labelcz: 'Afghanistan Central Business Registry (Ministry of Commerce and Industries)',
            labelen: 'Afghanistan Central Business Registry (Ministry of Commerce and Industries)'
        },
        {
            value: 'RA000759',
            labelcz: 'Register of Licensed Financial Institutions',
            labelen: 'Register of Licensed Financial Institutions'
        }
    ],
    AL: [
        {
            value: 'RA000002',
            labelcz: 'National Registration Center',
            labelen: 'National Registration Center'
        },
        {
            value: 'RA000793',
            labelcz: 'Albanian Financial Supervisory Authority (AFSA)',
            labelen: 'Albanian Financial Supervisory Authority (AFSA)'
        }
    ],
    DZ: [
        {
            value: 'RA000003',
            labelcz: 'National Center of the Trade Register',
            labelen: 'National Center of the Trade Register'
        },
        {
            value: 'RA000794',
            labelcz: "Commission d'Organisation et de Surveillance des Opérations de Bourse (COSOB)",
            labelen: "Commission d'Organisation et de Surveillance des Opérations de Bourse (COSOB)"
        },
        {
            value: 'RA000795',
            labelcz: 'Bank of Algeria',
            labelen: 'Bank of Algeria'
        }
    ],
    AD: [
        {
            value: 'RA000004',
            labelcz: 'Register of Commerce',
            labelen: 'Register of Commerce'
        },
        {
            value: 'RA000661',
            labelcz: 'Official AFA Register',
            labelen: 'Official AFA Register'
        }
    ],
    AO: [
        {
            value: 'RA000005',
            labelcz: 'Central Registry of Business Names',
            labelen: 'Central Registry of Business Names'
        },
        {
            value: 'RA000797',
            labelcz: 'Comissao do Mercado de Capitais (CMC)',
            labelen: 'Comissao do Mercado de Capitais (CMC)'
        },
        {
            value: 'RA000798',
            labelcz: 'National Bank of Angola',
            labelen: 'National Bank of Angola'
        }
    ],
    AI: [
        {
            value: 'RA000006',
            labelcz: 'Anguilla Commercial Registry',
            labelen: 'Anguilla Commercial Registry'
        },
        {
            value: 'RA000799',
            labelcz: 'Anguilla Financial Services Commission',
            labelen: 'Anguilla Financial Services Commission'
        }
    ],
    AG: [
        {
            value: 'RA000007',
            labelcz: 'Intellectual Property and Commerce Office',
            labelen: 'Intellectual Property and Commerce Office'
        },
        {
            value: 'RA000008',
            labelcz: 'Financial Services Regulatory Commission',
            labelen: 'Financial Services Regulatory Commission'
        }
    ],
    AR: [
        {
            value: 'RA000009',
            labelcz: 'Federal Administration of Public Revenues (AFIP)',
            labelen: 'Federal Administration of Public Revenues (AFIP)'
        },
        {
            value: 'RA000010',
            labelcz: 'Registro Nacional de Sociedades',
            labelen: 'Registro Nacional de Sociedades'
        },
        {
            value: 'RA000800',
            labelcz: 'Comisión Nacional de Valores; Ministerio de Economía',
            labelen: 'Comisión Nacional de Valores; Ministerio de Economía'
        }
    ],
    AM: [
        {
            value: 'RA000011',
            labelcz: 'State Register of Legal Entities',
            labelen: 'State Register of Legal Entities'
        },
        {
            value: 'RA000801',
            labelcz: 'Central Bank of Armenia',
            labelen: 'Central Bank of Armenia'
        }
    ],
    AW: [
        {
            value: 'RA000012',
            labelcz: 'Trade Register',
            labelen: 'Trade Register'
        },
        {
            value: 'RA000802',
            labelcz: 'Central Bank of Aruba (CBA)',
            labelen: 'Central Bank of Aruba (CBA)'
        }
    ],
    AU: [
        {
            value: 'RA000013',
            labelcz: 'Australian Business Register of the Australian Taxation Office',
            labelen: 'Australian Business Register of the Australian Taxation Office'
        },
        {
            value: 'RA000014',
            labelcz: 'Register of Companies',
            labelen: 'Register of Companies'
        },
        {
            value: 'RA000015',
            labelcz: 'Register of Financial Services Licensees',
            labelen: 'Register of Financial Services Licensees'
        },
        {
            value: 'RA000016',
            labelcz: 'Office of the Registrar of Indigenous Corporations (ORIC)',
            labelen: 'Office of the Registrar of Indigenous Corporations (ORIC)'
        },
        {
            value: 'RA000714',
            labelcz: 'Registrable Superannuation Entities (RSE) Register',
            labelen: 'Registrable Superannuation Entities (RSE) Register'
        },
        {
            value: 'RA000762',
            labelcz: 'Super Fund Lookup',
            labelen: 'Super Fund Lookup'
        },
        {
            value: 'RA001085',
            labelcz: 'ACNC Charity Register',
            labelen: 'ACNC Charity Register'
        }
    ],
    AT: [
        {
            value: 'RA000017',
            labelcz: 'Commercial Register',
            labelen: 'Commercial Register'
        },
        {
            value: 'RA000018',
            labelcz: 'Financial Market Authority',
            labelen: 'Financial Market Authority'
        },
        {
            value: 'RA000687',
            labelcz: 'Trade Information System Austria',
            labelen: 'Trade Information System Austria'
        },
        {
            value: 'RA000707',
            labelcz: 'Supplementary Register',
            labelen: 'Supplementary Register'
        },
        {
            value: 'RA000710',
            labelcz: 'Register of Associations',
            labelen: 'Register of Associations'
        },
        {
            value: 'RA000725',
            labelcz: 'Parishes - Evangelical Church of Austria',
            labelen: 'Parishes - Evangelical Church of Austria'
        },
        {
            value: 'RA000734',
            labelcz: 'Funds register',
            labelen: 'Funds register'
        },
        {
            value: 'RA001051',
            labelcz: 'Federal Ministry Agriculture, Forestry, Regions and Water Management',
            labelen: 'Federal Ministry Agriculture, Forestry, Regions and Water Management'
        },
        {
            value: 'RA001069',
            labelcz: 'Federal Ministry of the Interior - Parteienregister',
            labelen: 'Federal Ministry of the Interior - Parteienregister'
        },
        {
            value: 'RA001088',
            labelcz: 'Österreichischen Ärztekammer - Ärzteliste',
            labelen: 'Österreichischen Ärztekammer - Ärzteliste'
        },
        {
            value: 'RA001089',
            labelcz: 'Österreichischen Zahnärztekammer - Zahnärzteliste',
            labelen: 'Österreichischen Zahnärztekammer - Zahnärzteliste'
        },
        {
            value: 'RA001090',
            labelcz: 'Österreichischen Hebammengremium - Hebammenregister',
            labelen: 'Österreichischen Hebammengremium - Hebammenregister'
        },
        {
            value: 'RA001091',
            labelcz: 'Gesundheitsberuferegister',
            labelen: 'Gesundheitsberuferegister'
        },
        {
            value: 'RA001092',
            labelcz: 'Datenbank des Gesundheitsministeriums',
            labelen: 'Datenbank des Gesundheitsministeriums'
        }
    ],
    AZ: [
        {
            value: 'RA000019',
            labelcz: 'State Register of Commercial Entities',
            labelen: 'State Register of Commercial Entities'
        },
        {
            value: 'RA000804',
            labelcz: 'The Central Bank of the Republic of Azerbaijan',
            labelen: 'The Central Bank of the Republic of Azerbaijan'
        }
    ],
    BS: [
        {
            value: 'RA000020',
            labelcz: 'Registrar General Department of the Bahamas',
            labelen: 'Registrar General Department of the Bahamas'
        },
        {
            value: 'RA000805',
            labelcz: 'Securities Commission of the Bahamas',
            labelen: 'Securities Commission of the Bahamas'
        },
        {
            value: 'RA000806',
            labelcz: 'Central Bank of The Bahamas',
            labelen: 'Central Bank of The Bahamas'
        }
    ],
    BH: [
        {
            value: 'RA000021',
            labelcz: 'Bahrain Ministry Of Industry And Commerce',
            labelen: 'Bahrain Ministry Of Industry And Commerce'
        },
        {
            value: 'RA000807',
            labelcz: 'Central Bank of Bahrain',
            labelen: 'Central Bank of Bahrain'
        }
    ],
    BD: [
        {
            value: 'RA000022',
            labelcz: 'Office of the Registrar of Joint Stock Companies and Firms',
            labelen: 'Office of the Registrar of Joint Stock Companies and Firms'
        },
        {
            value: 'RA000808',
            labelcz: 'Bangladesh Securities and Exchange Commission',
            labelen: 'Bangladesh Securities and Exchange Commission'
        },
        {
            value: 'RA001094',
            labelcz: 'Online Trade License Verification',
            labelen: 'Online Trade License Verification'
        },
        {
            value: 'RA001110',
            labelcz: 'National Board of Revenue',
            labelen: 'National Board of Revenue'
        }
    ],
    BB: [
        {
            value: 'RA000023',
            labelcz: 'Corporate Affairs and Intellectual Property Office',
            labelen: 'Corporate Affairs and Intellectual Property Office'
        },
        {
            value: 'RA000809',
            labelcz: 'Financial Services Commission',
            labelen: 'Financial Services Commission'
        }
    ],
    BY: [
        {
            value: 'RA000024',
            labelcz: 'United State Register of Legal Entities and Individual Entrepreneurs',
            labelen: 'United State Register of Legal Entities and Individual Entrepreneurs'
        },
        {
            value: 'RA000810',
            labelcz: 'National Bank of the Republic of Belarus',
            labelen: 'National Bank of the Republic of Belarus'
        },
        {
            value: 'RA000811',
            labelcz: 'Securities Department, Ministry of Finance of the Republic of Belarus',
            labelen: 'Securities Department, Ministry of Finance of the Republic of Belarus'
        }
    ],
    BE: [
        {
            value: 'RA000025',
            labelcz: 'Crossroad Bank of Enterprises',
            labelen: 'Crossroad Bank of Enterprises'
        },
        {
            value: 'RA000812',
            labelcz: 'Financial Services and Markets Authority',
            labelen: 'Financial Services and Markets Authority'
        },
        {
            value: 'RA00146',
            labelcz: 'Register of Collective Investment Undertakings',
            labelen: 'Register of Collective Investment Undertakings'
        }
    ],
    BZ: [
        {
            value: 'RA000026',
            labelcz: 'Belize Companies & Corporate Affairs Registry',
            labelen: 'Belize Companies & Corporate Affairs Registry'
        },
        {
            value: 'RA000693',
            labelcz: 'International Business Companies Registry of Belize',
            labelen: 'International Business Companies Registry of Belize'
        },
        {
            value: 'RA000813',
            labelcz: 'International Financial Services Commission',
            labelen: 'International Financial Services Commission'
        }
    ],
    BJ: [
        {
            value: 'RA000027',
            labelcz: 'Chamber of Commerce and Industry of Benin',
            labelen: 'Chamber of Commerce and Industry of Benin'
        },
        {
            value: 'RA000814',
            labelcz: 'Central Bank of West African States (BCEAO)',
            labelen: 'Central Bank of West African States (BCEAO)'
        }
    ],
    BM: [
        {
            value: 'RA000028',
            labelcz: 'Registrar of Companies (Ministry of Economic Development)',
            labelen: 'Registrar of Companies (Ministry of Economic Development)'
        },
        {
            value: 'RA000029',
            labelcz: 'Bermuda Monetary Authority',
            labelen: 'Bermuda Monetary Authority'
        }
    ],
    BT: [
        {
            value: 'RA000030',
            labelcz: 'Company Registry Division, Department of Industry, Ministry of Economic Affairs',
            labelen: 'Company Registry Division, Department of Industry, Ministry of Economic Affairs'
        },
        {
            value: 'RA000815',
            labelcz: 'Royal Monetary Authority of Bhutan',
            labelen: 'Royal Monetary Authority of Bhutan'
        }
    ],
    BO: [
        {
            value: 'RA000816',
            labelcz: 'Superintendencia de Valores',
            labelen: 'Superintendencia de Valores'
        },
        {
            value: 'RA000817',
            labelcz: 'Autoridad de Supervisión del Sistema Financiero',
            labelen: 'Autoridad de Supervisión del Sistema Financiero'
        },
        {
            value: 'RA001062',
            labelcz: 'Registro de Comercio',
            labelen: 'Registro de Comercio'
        }
    ],
    BQ: [
        {
            value: 'RA000032',
            labelcz: 'Chamber of Commerce and Industry Bonaire',
            labelen: 'Chamber of Commerce and Industry Bonaire'
        },
        {
            value: 'RA000033',
            labelcz: 'Chamber of Commerce and Industry Sint Eustatius and Saba',
            labelen: 'Chamber of Commerce and Industry Sint Eustatius and Saba'
        }
    ],
    BA: [
        {
            value: 'RA000034',
            labelcz: 'Registers of Business Entities in Bosnia and Herzegovina',
            labelen: 'Registers of Business Entities in Bosnia and Herzegovina'
        },
        {
            value: 'RA000692',
            labelcz: 'Register of Business Entities',
            labelen: 'Register of Business Entities'
        },
        {
            value: 'RA000818',
            labelcz: 'Securities Commission of Federation of Bosnia and Herzegovina',
            labelen: 'Securities Commission of Federation of Bosnia and Herzegovina'
        },
        {
            value: 'RA000819',
            labelcz: 'Republic of Srpska Securities Commission',
            labelen: 'Republic of Srpska Securities Commission'
        }
    ],
    BW: [
        {
            value: 'RA000035',
            labelcz: 'Register of Companies',
            labelen: 'Register of Companies'
        },
        {
            value: 'RA000820',
            labelcz: 'The Bank of Botswana',
            labelen: 'The Bank of Botswana'
        },
        {
            value: 'RA000821',
            labelcz: 'Non-Bank Financial Institutions Regulatory Authority (NBFIRA)',
            labelen: 'Non-Bank Financial Institutions Regulatory Authority (NBFIRA)'
        }
    ],
    BR: [
        {
            value: 'RA000062',
            labelcz: 'JUCEAC Board of Trade of State of Acre',
            labelen: 'JUCEAC Board of Trade of State of Acre'
        },
        {
            value: 'RA000036',
            labelcz: 'JUCEAL Board of Trade of State of Alagoas',
            labelen: 'JUCEAL Board of Trade of State of Alagoas'
        },
        {
            value: 'RA000037',
            labelcz: 'JUCAP Board of Trade of State of Amapa',
            labelen: 'JUCAP Board of Trade of State of Amapa'
        },
        {
            value: 'RA000038',
            labelcz: 'JUCEA Board of Trade of State of Amazon',
            labelen: 'JUCEA Board of Trade of State of Amazon'
        },
        {
            value: 'RA000039',
            labelcz: 'JUCEB Board of Trade of State of Bahia',
            labelen: 'JUCEB Board of Trade of State of Bahia'
        },
        {
            value: 'RA000681',
            labelcz: 'National Registry for Legal Entity',
            labelen: 'National Registry for Legal Entity'
        },
        {
            value: 'RA000040',
            labelcz: 'JUCEC Board of Trade of State of Ceara',
            labelen: 'JUCEC Board of Trade of State of Ceara'
        },
        {
            value: 'RA000041',
            labelcz: 'JCDF Board of Trade of State of Federal District',
            labelen: 'JCDF Board of Trade of State of Federal District'
        },
        {
            value: 'RA000042',
            labelcz: 'JUCEES Board of Trade of State of Espirito Santo',
            labelen: 'JUCEES Board of Trade of State of Espirito Santo'
        },
        {
            value: 'RA000043',
            labelcz: 'JUCEG Board of Trade of State of Goias',
            labelen: 'JUCEG Board of Trade of State of Goias'
        },
        {
            value: 'RA000044',
            labelcz: 'JUCEMA Board of Trade of State of Maranhao',
            labelen: 'JUCEMA Board of Trade of State of Maranhao'
        },
        {
            value: 'RA000046',
            labelcz: 'JUCEMS Board of Trade of State of Mato Grosso do Sul',
            labelen: 'JUCEMS Board of Trade of State of Mato Grosso do Sul'
        },
        {
            value: 'RA000045',
            labelcz: 'JUCEMAT Board of Trade of State of Mato Grosso',
            labelen: 'JUCEMAT Board of Trade of State of Mato Grosso'
        },
        {
            value: 'RA000047',
            labelcz: 'JUCEMG Board of Trade of State of Minas Gerais',
            labelen: 'JUCEMG Board of Trade of State of Minas Gerais'
        },
        {
            value: 'RA000048',
            labelcz: 'JUCEPA Board of Trade of State of Para',
            labelen: 'JUCEPA Board of Trade of State of Para'
        },
        {
            value: 'RA000049',
            labelcz: 'JUCEP Board of Trade of State of Paraiba',
            labelen: 'JUCEP Board of Trade of State of Paraiba'
        },
        {
            value: 'RA000050',
            labelcz: 'JUCEPAR Board of Trade of State of Parana',
            labelen: 'JUCEPAR Board of Trade of State of Parana'
        },
        {
            value: 'RA000051',
            labelcz: 'JUCEPE Board of Trade of State of Pernambuco',
            labelen: 'JUCEPE Board of Trade of State of Pernambuco'
        },
        {
            value: 'RA000052',
            labelcz: 'JUCEPI Board of Trade of State of Piaui',
            labelen: 'JUCEPI Board of Trade of State of Piaui'
        },
        {
            value: 'RA000054',
            labelcz: 'JUCERN Board of Trade of State of North Rio Grande',
            labelen: 'JUCERN Board of Trade of State of North Rio Grande'
        },
        {
            value: 'RA000055',
            labelcz: 'JUCERGC Board of Trade of State of South Rio Grande',
            labelen: 'JUCERGC Board of Trade of State of South Rio Grande'
        },
        {
            value: 'RA000053',
            labelcz: 'JUCERJA Board of Trade of State of Rio de Janeiro',
            labelen: 'JUCERJA Board of Trade of State of Rio de Janeiro'
        },
        {
            value: 'RA000056',
            labelcz: 'JUCER Board of Trade of State of Rondonia',
            labelen: 'JUCER Board of Trade of State of Rondonia'
        },
        {
            value: 'RA000057',
            labelcz: 'JUCERR Board of Trade of State of Roraima',
            labelen: 'JUCERR Board of Trade of State of Roraima'
        },
        {
            value: 'RA000059',
            labelcz: 'JUCESP Board of Trade of State of Sao Paulo',
            labelen: 'JUCESP Board of Trade of State of Sao Paulo'
        },
        {
            value: 'RA000058',
            labelcz: 'JUCESC Board of Trade of State of Santa Catarina',
            labelen: 'JUCESC Board of Trade of State of Santa Catarina'
        },
        {
            value: 'RA000060',
            labelcz: 'JUCESE Board of Trade of State of Sergipe',
            labelen: 'JUCESE Board of Trade of State of Sergipe'
        },
        {
            value: 'RA000061',
            labelcz: 'JUCETINS Board of Trade of State of Tocantins',
            labelen: 'JUCETINS Board of Trade of State of Tocantins'
        },
        {
            value: 'RA000822',
            labelcz: 'Banco Central do Brasil',
            labelen: 'Banco Central do Brasil'
        },
        {
            value: 'RA000823',
            labelcz: 'Junta Comercial do Mato Grosso do Sul (MS)',
            labelen: 'Junta Comercial do Mato Grosso do Sul (MS)'
        }
    ],
    VG: [
        {
            value: 'RA000063',
            labelcz: 'Registry of Corporate Affairs (British Virgin Islands Financial Services Commission)',
            labelen: 'Registry of Corporate Affairs (British Virgin Islands Financial Services Commission)'
        }
    ],
    BN: [
        {
            value: 'RA000064',
            labelcz: 'Registry of Companies and Business Names (Ministry of Finance)',
            labelen: 'Registry of Companies and Business Names (Ministry of Finance)'
        },
        {
            value: 'RA000824',
            labelcz: '​Brunei Darussalam Central Bank (BDCB)',
            labelen: '​Brunei Darussalam Central Bank (BDCB)'
        }
    ],
    BG: [
        {
            value: 'RA000065',
            labelcz: 'Commercial Register - Registry Agency (Ministry of Justice)',
            labelen: 'Commercial Register - Registry Agency (Ministry of Justice)'
        },
        {
            value: 'RA000066',
            labelcz: 'Public register and filing cabinet',
            labelen: 'Public register and filing cabinet'
        },
        {
            value: 'RA000730',
            labelcz: 'Bulstat Registry',
            labelen: 'Bulstat Registry'
        },
        {
            value: 'RA000731',
            labelcz: 'Register of non-profit legal entities for public benefit',
            labelen: 'Register of non-profit legal entities for public benefit'
        }
    ],
    BF: [
        {
            value: 'RA000067',
            labelcz: 'House of Enterprises of Burkina Faso',
            labelen: 'House of Enterprises of Burkina Faso'
        },
        {
            value: 'RA000814',
            labelcz: 'Central Bank of West African States (BCEAO)',
            labelen: 'Central Bank of West African States (BCEAO)'
        }
    ],
    BI: [
        {
            value: 'RA000068',
            labelcz: 'Burundi Investment Promotion Agency (API)',
            labelen: 'Burundi Investment Promotion Agency (API)'
        },
        {
            value: 'RA000825',
            labelcz: 'Bank of the Republic of Burundi',
            labelen: 'Bank of the Republic of Burundi'
        }
    ],
    CV: [
        {
            value: 'RA000069',
            labelcz: 'Cabo Verde Commercial Registry',
            labelen: 'Cabo Verde Commercial Registry'
        },
        {
            value: 'RA000683',
            labelcz: 'Funds registration',
            labelen: 'Funds registration'
        },
        {
            value: 'RA000826',
            labelcz: 'Auditoria Geral do Mercado de Valores Mobiliários, Banco Central of Cabo Verde',
            labelen: 'Auditoria Geral do Mercado de Valores Mobiliários, Banco Central of Cabo Verde'
        }
    ],
    KH: [
        {
            value: 'RA000070',
            labelcz: 'Commercial Register - Ministry of Commerce',
            labelen: 'Commercial Register - Ministry of Commerce'
        },
        {
            value: 'RA000827',
            labelcz: 'Securities and Exchange Regulator of Cambodia',
            labelen: 'Securities and Exchange Regulator of Cambodia'
        },
        {
            value: 'RA000828',
            labelcz: 'The National Bank of Cambodia (NBC)',
            labelen: 'The National Bank of Cambodia (NBC)'
        }
    ],
    CM: [
        {
            value: 'RA000071',
            labelcz: 'Planning and Regional Development (Ministry of Economy)',
            labelen: 'Planning and Regional Development (Ministry of Economy)'
        },
        {
            value: 'RA001055',
            labelcz: 'Trade and Personal Property Credit Register',
            labelen: 'Trade and Personal Property Credit Register'
        }
    ],
    CA: [
        {
            value: 'RA000073',
            labelcz: 'Corporate Registry (Province of Alberta)',
            labelen: 'Corporate Registry (Province of Alberta)'
        },
        {
            value: 'RA000074',
            labelcz: 'Corporate Registry (Province of British Columbia)',
            labelen: 'Corporate Registry (Province of British Columbia)'
        },
        {
            value: 'RA000072',
            labelcz: 'Corporate Registry',
            labelen: 'Corporate Registry'
        },
        {
            value: 'RA000075',
            labelcz: 'Companies Registry',
            labelen: 'Companies Registry'
        },
        {
            value: 'RA000076',
            labelcz: 'Corporate Registry (Province of New Brunswick)',
            labelen: 'Corporate Registry (Province of New Brunswick)'
        },
        {
            value: 'RA000077',
            labelcz: 'Registry of Companies (Province of Newfoundland and Labrador)',
            labelen: 'Registry of Companies (Province of Newfoundland and Labrador)'
        },
        {
            value: 'RA000083',
            labelcz: 'Corporate Registry (Department of Justice)',
            labelen: 'Corporate Registry (Department of Justice)'
        },
        {
            value: 'RA000078',
            labelcz: 'Registry of Joint Stock Companies (Province of Nova Scotia)',
            labelen: 'Registry of Joint Stock Companies (Province of Nova Scotia)'
        },
        {
            value: 'RA000084',
            labelcz: 'Corporate Registry (Department of Justice)',
            labelen: 'Corporate Registry (Department of Justice)'
        },
        {
            value: 'RA000079',
            labelcz: 'Corporate Registry (Province of Ontario)',
            labelen: 'Corporate Registry (Province of Ontario)'
        },
        {
            value: 'RA000080',
            labelcz: 'Prince Edward Island Corporate/Business Names Registry',
            labelen: 'Prince Edward Island Corporate/Business Names Registry'
        },
        {
            value: 'RA000081',
            labelcz: 'Enterprise Register (Services Quebec)',
            labelen: 'Enterprise Register (Services Quebec)'
        },
        {
            value: 'RA000082',
            labelcz: 'Saskatchewan Corporate Registry',
            labelen: 'Saskatchewan Corporate Registry'
        },
        {
            value: 'RA000085',
            labelcz: 'Corporate Registry',
            labelen: 'Corporate Registry'
        },
        {
            value: 'RA000832',
            labelcz: 'Alberta Securities Commission',
            labelen: 'Alberta Securities Commission'
        },
        {
            value: 'RA000833',
            labelcz: 'British Columbia Securities Commission',
            labelen: 'British Columbia Securities Commission'
        },
        {
            value: 'RA000830',
            labelcz: 'Canadian Securities Administrators',
            labelen: 'Canadian Securities Administrators'
        },
        {
            value: 'RA000831',
            labelcz: 'Office of the Superintendent of Financial Institutions (OFSI)',
            labelen: 'Office of the Superintendent of Financial Institutions (OFSI)'
        },
        {
            value: 'RA000834',
            labelcz: 'Manitoba Securities Commission',
            labelen: 'Manitoba Securities Commission'
        },
        {
            value: 'RA000835',
            labelcz: 'Financial and Consumer Services Commission',
            labelen: 'Financial and Consumer Services Commission'
        },
        {
            value: 'RA000836',
            labelcz: 'Financial Services Regulation Division',
            labelen: 'Financial Services Regulation Division'
        },
        {
            value: 'RA000837',
            labelcz: 'Office of the Superintendent of Securities',
            labelen: 'Office of the Superintendent of Securities'
        },
        {
            value: 'RA000838',
            labelcz: 'Nova Scotia Securities Commission',
            labelen: 'Nova Scotia Securities Commission'
        },
        {
            value: 'RA000839',
            labelcz: 'Office of the Superintendent of Securities',
            labelen: 'Office of the Superintendent of Securities'
        },
        {
            value: 'RA000840',
            labelcz: 'Ontario Securities Commission (OSC)',
            labelen: 'Ontario Securities Commission (OSC)'
        },
        {
            value: 'RA000841',
            labelcz: 'Office of the Superintendent of Securities Office',
            labelen: 'Office of the Superintendent of Securities Office'
        },
        {
            value: 'RA000842',
            labelcz: 'Financial Markets Authority',
            labelen: 'Financial Markets Authority'
        },
        {
            value: 'RA000843',
            labelcz: 'Financial and Consumer Affairs Authority',
            labelen: 'Financial and Consumer Affairs Authority'
        },
        {
            value: 'RA000844',
            labelcz: 'Superintendent of Securities',
            labelen: 'Superintendent of Securities'
        },
        {
            value: 'RA001070',
            labelcz: 'Financial Services Regulatory Authority of Ontario - Pension Plan Information',
            labelen: 'Financial Services Regulatory Authority of Ontario - Pension Plan Information'
        },
        {
            value: 'RA001116',
            labelcz: 'Information de régimes de retraite - Pension Plan Information',
            labelen: 'Information de régimes de retraite - Pension Plan Information'
        },
        {
            value: 'RA001121',
            labelcz: 'List of Charities',
            labelen: 'List of Charities'
        }
    ],
    KY: [
        {
            value: 'RA000086',
            labelcz: 'Registry of Companies',
            labelen: 'Registry of Companies'
        },
        {
            value: 'RA000087',
            labelcz: 'Cayman Islands Monetary Authority',
            labelen: 'Cayman Islands Monetary Authority'
        }
    ],
    CF: [
        {
            value: 'RA000088',
            labelcz: 'Commercial Registry (Tribunal)',
            labelen: 'Commercial Registry (Tribunal)'
        },
        {
            value: 'RA000829',
            labelcz: 'Bank of Central African States (BEAC)',
            labelen: 'Bank of Central African States (BEAC)'
        },
        {
            value: 'RA000845',
            labelcz: 'Securities and Exchange Commission of Central Africa)',
            labelen: 'Securities and Exchange Commission of Central Africa)'
        }
    ],
    TD: [
        {
            value: 'RA000089',
            labelcz: 'Registry of Commerce and Real Estate',
            labelen: 'Registry of Commerce and Real Estate'
        },
        {
            value: 'RA000829',
            labelcz: 'Bank of Central African States (BEAC)',
            labelen: 'Bank of Central African States (BEAC)'
        }
    ],
    CL: [
        {
            value: 'RA000090',
            labelcz: 'Registry of Commerce',
            labelen: 'Registry of Commerce'
        },
        {
            value: 'RA000785',
            labelcz: 'Register of Companies and Societies',
            labelen: 'Register of Companies and Societies'
        },
        {
            value: 'RA000787',
            labelcz: 'Internal Revenue Service',
            labelen: 'Internal Revenue Service'
        },
        {
            value: 'RA000091',
            labelcz: 'Registro de Comercio',
            labelen: 'Registro de Comercio'
        },
        {
            value: 'RA000846',
            labelcz: 'Financial Market Commission',
            labelen: 'Financial Market Commission'
        }
    ],
    CN: [
        {
            value: 'RA000092',
            labelcz: 'National Enterprise Credit Information Publicity System',
            labelen: 'National Enterprise Credit Information Publicity System'
        },
        {
            value: 'RA000829',
            labelcz: 'Bank of Central African States (BEAC)',
            labelen: 'Bank of Central African States (BEAC)'
        },
        {
            value: 'RA000847',
            labelcz: 'China Securities Regulatory Commission (CSRC)',
            labelen: 'China Securities Regulatory Commission (CSRC)'
        }
    ],
    CO: [
        {
            value: 'RA000094',
            labelcz: 'Aburra Sur Chamber of Commerce',
            labelen: 'Aburra Sur Chamber of Commerce'
        },
        {
            value: 'RA000095',
            labelcz: 'Aguachica Chamber of Commerce',
            labelen: 'Aguachica Chamber of Commerce'
        },
        {
            value: 'RA000096',
            labelcz: 'Amazonas Chamber of Commerce',
            labelen: 'Amazonas Chamber of Commerce'
        },
        {
            value: 'RA000097',
            labelcz: 'Arauca Chamber of Commerce',
            labelen: 'Arauca Chamber of Commerce'
        },
        {
            value: 'RA000098',
            labelcz: 'Armenia y del Quindío Chamber of Commerce',
            labelen: 'Armenia y del Quindío Chamber of Commerce'
        },
        {
            value: 'RA000099',
            labelcz: 'Barrancabermeja  Chamber of Commerce',
            labelen: 'Barrancabermeja  Chamber of Commerce'
        },
        {
            value: 'RA000100',
            labelcz: 'Barranquilla Chamber of Commerce',
            labelen: 'Barranquilla Chamber of Commerce'
        },
        {
            value: 'RA000101',
            labelcz: 'Bogotá Chamber of Commerce',
            labelen: 'Bogotá Chamber of Commerce'
        },
        {
            value: 'RA000102',
            labelcz: 'Bucaramanga Chamber of Commerce',
            labelen: 'Bucaramanga Chamber of Commerce'
        },
        {
            value: 'RA000103',
            labelcz: 'Buenaventura Chamber of Commerce',
            labelen: 'Buenaventura Chamber of Commerce'
        },
        {
            value: 'RA000104',
            labelcz: 'Buga Chamber of Commerce',
            labelen: 'Buga Chamber of Commerce'
        },
        {
            value: 'RA000110',
            labelcz: 'Cúcuta  Chamber of Commerce',
            labelen: 'Cúcuta  Chamber of Commerce'
        },
        {
            value: 'RA000105',
            labelcz: 'Cali Chamber of Commerce',
            labelen: 'Cali Chamber of Commerce'
        },
        {
            value: 'RA000106',
            labelcz: 'Cartagena Chamber of Commerce',
            labelen: 'Cartagena Chamber of Commerce'
        },
        {
            value: 'RA000107',
            labelcz: 'Cartago Chamber of Commerce',
            labelen: 'Cartago Chamber of Commerce'
        },
        {
            value: 'RA000108',
            labelcz: 'Casanare Chamber of Commerce',
            labelen: 'Casanare Chamber of Commerce'
        },
        {
            value: 'RA000109',
            labelcz: 'Cauca Chamber of Commerce',
            labelen: 'Cauca Chamber of Commerce'
        },
        {
            value: 'RA000111',
            labelcz: 'Chinchiná Chamber of Commerce',
            labelen: 'Chinchiná Chamber of Commerce'
        },
        {
            value: 'RA000136',
            labelcz: 'Chocó  Chamber of Commerce',
            labelen: 'Chocó  Chamber of Commerce'
        },
        {
            value: 'RA000093',
            labelcz: 'Single Business Register',
            labelen: 'Single Business Register'
        },
        {
            value: 'RA000112',
            labelcz: 'Dosquebradas Chamber of Commerce',
            labelen: 'Dosquebradas Chamber of Commerce'
        },
        {
            value: 'RA000113',
            labelcz: 'Duitama Chamber of Commerce',
            labelen: 'Duitama Chamber of Commerce'
        },
        {
            value: 'RA000114',
            labelcz: 'Facatativá Chamber of Commerce',
            labelen: 'Facatativá Chamber of Commerce'
        },
        {
            value: 'RA000115',
            labelcz: 'Florencia Chamber of Commerce',
            labelen: 'Florencia Chamber of Commerce'
        },
        {
            value: 'RA000116',
            labelcz: 'Girardot Chamber of Commerce',
            labelen: 'Girardot Chamber of Commerce'
        },
        {
            value: 'RA000117',
            labelcz: 'Honda Chamber of Commerce',
            labelen: 'Honda Chamber of Commerce'
        },
        {
            value: 'RA000118',
            labelcz: 'Ibagué Chamber of Commerce',
            labelen: 'Ibagué Chamber of Commerce'
        },
        {
            value: 'RA000119',
            labelcz: 'Ipiales Chamber of Commerce',
            labelen: 'Ipiales Chamber of Commerce'
        },
        {
            value: 'RA000120',
            labelcz: 'La Dorada, Puerto Boyaca, Puerto Salgar y Oriente De Caldas Chamber of Commerce',
            labelen: 'La Dorada, Puerto Boyaca, Puerto Salgar y Oriente De Caldas Chamber of Commerce'
        },
        {
            value: 'RA000121',
            labelcz: 'La Guajira Chamber of Commerce',
            labelen: 'La Guajira Chamber of Commerce'
        },
        {
            value: 'RA000122',
            labelcz: 'Magangué Chamber of Commerce',
            labelen: 'Magangué Chamber of Commerce'
        },
        {
            value: 'RA000123',
            labelcz: 'Magdalena Medio y Nordeste Antioqueño Chamber of Commerce',
            labelen: 'Magdalena Medio y Nordeste Antioqueño Chamber of Commerce'
        },
        {
            value: 'RA000124',
            labelcz: 'Manizales Chamber of Commerce',
            labelen: 'Manizales Chamber of Commerce'
        },
        {
            value: 'RA000125',
            labelcz: 'Medellín Chamber of Commerce',
            labelen: 'Medellín Chamber of Commerce'
        },
        {
            value: 'RA000126',
            labelcz: 'Montería Chamber of Commerce',
            labelen: 'Montería Chamber of Commerce'
        },
        {
            value: 'RA000127',
            labelcz: 'Neiva Chamber of Commerce',
            labelen: 'Neiva Chamber of Commerce'
        },
        {
            value: 'RA000128',
            labelcz: 'Ocaña Chamber of Commerce',
            labelen: 'Ocaña Chamber of Commerce'
        },
        {
            value: 'RA000129',
            labelcz: 'Oriente Antioqueño Chamber of Commerce',
            labelen: 'Oriente Antioqueño Chamber of Commerce'
        },
        {
            value: 'RA000130',
            labelcz: 'Palmira Chamber of Commerce',
            labelen: 'Palmira Chamber of Commerce'
        },
        {
            value: 'RA000131',
            labelcz: 'Pamplona Chamber of Commerce',
            labelen: 'Pamplona Chamber of Commerce'
        },
        {
            value: 'RA000132',
            labelcz: 'Pasto Chamber of Commerce',
            labelen: 'Pasto Chamber of Commerce'
        },
        {
            value: 'RA000133',
            labelcz: 'Pereira Chamber of Commerce',
            labelen: 'Pereira Chamber of Commerce'
        },
        {
            value: 'RA000134',
            labelcz: 'Piedemonte Chamber of Commerce',
            labelen: 'Piedemonte Chamber of Commerce'
        },
        {
            value: 'RA000135',
            labelcz: 'Putumayo Chamber of Commerce',
            labelen: 'Putumayo Chamber of Commerce'
        },
        {
            value: 'RA000137',
            labelcz: 'San Andrés Chamber of Commerce',
            labelen: 'San Andrés Chamber of Commerce'
        },
        {
            value: 'RA000138',
            labelcz: 'San José Chamber of Commerce',
            labelen: 'San José Chamber of Commerce'
        },
        {
            value: 'RA000139',
            labelcz: 'Santa Marta Chamber of Commerce',
            labelen: 'Santa Marta Chamber of Commerce'
        },
        {
            value: 'RA000140',
            labelcz: 'Santa Rosa de Cabal Chamber of Commerce',
            labelen: 'Santa Rosa de Cabal Chamber of Commerce'
        },
        {
            value: 'RA000141',
            labelcz: 'Sevilla Chamber of Commerce',
            labelen: 'Sevilla Chamber of Commerce'
        },
        {
            value: 'RA000142',
            labelcz: 'Sincelejo Chamber of Commerce',
            labelen: 'Sincelejo Chamber of Commerce'
        },
        {
            value: 'RA000143',
            labelcz: 'Sogamoso Chamber of Commerce',
            labelen: 'Sogamoso Chamber of Commerce'
        },
        {
            value: 'RA000144',
            labelcz: 'Sur y Oriente del Tolima Chamber of Commerce',
            labelen: 'Sur y Oriente del Tolima Chamber of Commerce'
        },
        {
            value: 'RA000145',
            labelcz: 'Tuluá Chamber of Commerce',
            labelen: 'Tuluá Chamber of Commerce'
        },
        {
            value: 'RA000146',
            labelcz: 'Tumaco Chamber of Commerce',
            labelen: 'Tumaco Chamber of Commerce'
        },
        {
            value: 'RA000147',
            labelcz: 'Tunja  Chamber of Commerce',
            labelen: 'Tunja  Chamber of Commerce'
        },
        {
            value: 'RA000148',
            labelcz: 'Urabá Chamber of Commerce',
            labelen: 'Urabá Chamber of Commerce'
        },
        {
            value: 'RA000149',
            labelcz: 'Valledupar Chamber of Commerce',
            labelen: 'Valledupar Chamber of Commerce'
        },
        {
            value: 'RA000150',
            labelcz: 'Villavicencio Chamber of Commerce',
            labelen: 'Villavicencio Chamber of Commerce'
        },
        {
            value: 'RA000848',
            labelcz: 'Superintendencia Financiera',
            labelen: 'Superintendencia Financiera'
        }
    ],
    CG: [
        {
            value: 'RA000151',
            labelcz: 'Business Formalities Centre',
            labelen: 'Business Formalities Centre'
        },
        {
            value: 'RA000829',
            labelcz: 'Bank of Central African States (BEAC)',
            labelen: 'Bank of Central African States (BEAC)'
        },
        {
            value: 'RA000850',
            labelcz: 'Agence de Régulation des Transferts de Fonds (ARTF)',
            labelen: 'Agence de Régulation des Transferts de Fonds (ARTF)'
        }
    ],
    CK: [
        {
            value: 'RA000152',
            labelcz: 'Financial Supervisory Commission',
            labelen: 'Financial Supervisory Commission'
        },
        {
            value: 'RA000153',
            labelcz: 'Cook Islands Registry Services (Ministry of Justice)',
            labelen: 'Cook Islands Registry Services (Ministry of Justice)'
        }
    ],
    CR: [
        {
            value: 'RA000154',
            labelcz: 'National Register of Costa Rica',
            labelen: 'National Register of Costa Rica'
        },
        {
            value: 'RA000852',
            labelcz: 'Superintendencia General de Valores (Sugeval)',
            labelen: 'Superintendencia General de Valores (Sugeval)'
        },
        {
            value: 'RA000853',
            labelcz: 'Superintendencia General de Entidades Financieras (SUGEF)',
            labelen: 'Superintendencia General de Entidades Financieras (SUGEF)'
        }
    ],
    HR: [
        {
            value: 'RA000156',
            labelcz: 'Croatian Court Registry (Ministry of Justice)',
            labelen: 'Croatian Court Registry (Ministry of Justice)'
        },
        {
            value: 'RA000157',
            labelcz: 'Funds Registration',
            labelen: 'Funds Registration'
        },
        {
            value: 'RA000659',
            labelcz: 'Crafts Register - Ministry of the Economy, Entrepreneurship and Crafts',
            labelen: 'Crafts Register - Ministry of the Economy, Entrepreneurship and Crafts'
        },
        {
            value: 'RA000686',
            labelcz: 'Register of Business Entities',
            labelen: 'Register of Business Entities'
        },
        {
            value: 'RA000695',
            labelcz: 'Register of legal persons of the Catholic Church',
            labelen: 'Register of legal persons of the Catholic Church'
        },
        {
            value: 'RA000696',
            labelcz: 'Register of Non-profit Organizations',
            labelen: 'Register of Non-profit Organizations'
        },
        {
            value: 'RA000705',
            labelcz: 'Register of Budget Users',
            labelen: 'Register of Budget Users'
        }
    ],
    CU: [
        {
            value: 'RA000158',
            labelcz: 'Statistics and Information National Office',
            labelen: 'Statistics and Information National Office'
        },
        {
            value: 'RA000159',
            labelcz: 'Ministry of Justice',
            labelen: 'Ministry of Justice'
        },
        {
            value: 'RA000854',
            labelcz: 'Central Bank of Cuba',
            labelen: 'Central Bank of Cuba'
        }
    ],
    CW: [
        {
            value: 'RA000160',
            labelcz: 'Chamber of Commerce and Industry Curaçao',
            labelen: 'Chamber of Commerce and Industry Curaçao'
        },
        {
            value: 'RA000855',
            labelcz: 'Central Bank of Curaçao and Sint Maarten',
            labelen: 'Central Bank of Curaçao and Sint Maarten'
        }
    ],
    CY: [
        {
            value: 'RA000161',
            labelcz: 'Department of Registrar of Companies and Official Receiver',
            labelen: 'Department of Registrar of Companies and Official Receiver'
        },
        {
            value: 'RA000162',
            labelcz: 'Cyprus Securities and Exchange Commission',
            labelen: 'Cyprus Securities and Exchange Commission'
        },
        {
            value: 'RA001052',
            labelcz: 'Register of Occupational Retirement Funds',
            labelen: 'Register of Occupational Retirement Funds'
        },
        {
            value: 'RA001074',
            labelcz: 'Provident Funds',
            labelen: 'Provident Funds'
        }
    ],
    CZ: [
        {
            value: 'RA000163',
            labelcz: 'Obchodní rejstřík',
            labelen: 'Commercial Register'
        },
        {
            value: 'RA000164',
            labelcz: 'Spolkový rejstřík',
            labelen: 'Federal Register'
        },
        {
            value: 'RA000165',
            labelcz: 'Nadační rejstřík',
            labelen: 'Register of Foundations'
        },
        {
            value: 'RA000166',
            labelcz: 'Rejstřík ústavů',
            labelen: 'Register of Institutes'
        },
        {
            value: 'RA000167',
            labelcz: 'Rejstřík obecně prospěšných společností',
            labelen: 'Register of Public Service Companies'
        },
        {
            value: 'RA000168',
            labelcz: 'Registr ekonomických subjektů',
            labelen: 'Register of Economic Entities'
        },
        {
            value: 'RA000694',
            labelcz: 'Evidence svěřenských fondů',
            labelen: 'Evidence of trust funds'
        },
        {
            value: 'RA000856',
            labelcz: 'Česká národní banka (CNB)',
            labelen: 'Czech National Bank (CNB)'
        },
        {
            value: 'RA000857',
            labelcz: 'Živnostenský rejstřík',
            labelen: 'Ministry of Industry and Trade'
        },
        {
            value: 'RA000858',
            labelcz: 'Rejstřík církví a náboženských společností',
            labelen: 'Ministry of Culture'
        }
    ],
    CI: [
        {
            value: 'RA000155',
            labelcz: 'Registre du Commerce et du Crédit Mobilier',
            labelen: 'Registre du Commerce et du Crédit Mobilier'
        },
        {
            value: 'RA000814',
            labelcz: 'Central Bank of West African States (BCEAO)',
            labelen: 'Central Bank of West African States (BCEAO)'
        }
    ],
    CD: [
        {
            value: 'RA000169',
            labelcz: 'Registre du Commerce et du Crédit Mobilier (RCCM)',
            labelen: 'Registre du Commerce et du Crédit Mobilier (RCCM)'
        },
        {
            value: 'RA000851',
            labelcz: 'Central Bank of the Congo',
            labelen: 'Central Bank of the Congo'
        }
    ],
    DK: [
        {
            value: 'RA000170',
            labelcz: 'Central Business Register',
            labelen: 'Danish Business Authority'
        },
        {
            value: 'RA000171',
            labelcz: 'Financial Supervisory Authority',
            labelen: 'Financial Supervisory Authority'
        },
        {
            value: 'RA000860',
            labelcz: 'The Ministry of Ecclesiastical Affairs',
            labelen: 'The Ministry of Ecclesiastical Affairs'
        }
    ],
    DJ: [
        {
            value: 'RA000172',
            labelcz: 'Chamber of Commerce',
            labelen: 'Chamber of Commerce'
        },
        {
            value: 'RA000861',
            labelcz: 'The Central Bank of Djibouti',
            labelen: 'The Central Bank of Djibouti'
        }
    ],
    DM: [
        {
            value: 'RA000173',
            labelcz: 'National Companies and Intellectual Property Registry',
            labelen: 'National Companies and Intellectual Property Registry'
        },
        {
            value: 'RA000862',
            labelcz: 'Financial Services Unit (FSU)',
            labelen: 'Financial Services Unit (FSU)'
        }
    ],
    DO: [
        {
            value: 'RA000174',
            labelcz: 'National Office of Industrial Property',
            labelen: 'National Office of Industrial Property'
        },
        {
            value: 'RA000175',
            labelcz: 'Chamber of Commerce and Production of Santo Domingo',
            labelen: 'Chamber of Commerce and Production of Santo Domingo'
        },
        {
            value: 'RA000863',
            labelcz: 'Superintendencia del Mercado de Valores',
            labelen: 'Superintendencia del Mercado de Valores'
        },
        {
            value: 'RA000864',
            labelcz: 'Central Bank of the Dominican Republic',
            labelen: 'Central Bank of the Dominican Republic'
        },
        {
            value: 'RA000865',
            labelcz: 'The Superintendency of Banks',
            labelen: 'The Superintendency of Banks'
        },
        {
            value: 'RA001058',
            labelcz: 'Registro Nacional de Contribuyentes',
            labelen: 'Registro Nacional de Contribuyentes'
        }
    ],
    EC: [
        {
            value: 'RA000176',
            labelcz: 'Registry of Commerce of Ecuador',
            labelen: 'Registry of Commerce of Ecuador'
        },
        {
            value: 'RA000177',
            labelcz: 'National Registry of Statistics and Census',
            labelen: 'National Registry of Statistics and Census'
        },
        {
            value: 'RA000178',
            labelcz: 'Superintendence of Companies and Securities',
            labelen: 'Superintendence of Companies and Securities'
        },
        {
            value: 'RA000691',
            labelcz: 'Registro Único de Contribuyentes (RUC)',
            labelen: 'Registro Único de Contribuyentes (RUC)'
        },
        {
            value: 'RA000867',
            labelcz: 'Superintendencia de Bancos',
            labelen: 'Superintendencia de Bancos'
        },
        {
            value: 'RA000868',
            labelcz: 'Central Bank of Ecuador',
            labelen: 'Central Bank of Ecuador'
        },
        {
            value: 'RA001083',
            labelcz: 'Registro de organizaciones del sector finaciero',
            labelen: 'Registro de organizaciones del sector finaciero'
        }
    ],
    EG: [
        {
            value: 'RA000179',
            labelcz: 'Cairo Chamber of Commerce',
            labelen: 'Cairo Chamber of Commerce'
        },
        {
            value: 'RA000869',
            labelcz: 'Central Bank of Egypt',
            labelen: 'Central Bank of Egypt'
        },
        {
            value: 'RA000870',
            labelcz: 'Financial Regulatory Authority',
            labelen: 'Financial Regulatory Authority'
        }
    ],
    SV: [
        {
            value: 'RA000180',
            labelcz: 'National Registers Center',
            labelen: 'National Registers Center'
        },
        {
            value: 'RA000871',
            labelcz: 'Superintendencia del Sistema Financiero',
            labelen: 'Superintendencia del Sistema Financiero'
        }
    ],
    EE: [
        {
            value: 'RA000181',
            labelcz: 'Centre of Registers and Information Systems',
            labelen: 'Centre of Registers and Information Systems'
        },
        {
            value: 'RA000182',
            labelcz: 'Financial Supervision Authority ',
            labelen: 'Financial Supervision Authority '
        }
    ],
    ET: [
        {
            value: 'RA000183',
            labelcz: 'Ministry of Trade',
            labelen: 'Ministry of Trade'
        },
        {
            value: 'RA000874',
            labelcz: 'National Bank of Ethiopia',
            labelen: 'National Bank of Ethiopia'
        }
    ],
    FK: [
        {
            value: 'RA000184',
            labelcz: 'Registrar of Companies',
            labelen: 'Registrar of Companies'
        },
        {
            value: 'RA000875',
            labelcz: 'Government Treasury',
            labelen: 'Government Treasury'
        }
    ],
    FO: [
        {
            value: 'RA000185',
            labelcz: 'Company Registration Authority',
            labelen: 'Company Registration Authority'
        },
        {
            value: 'RA000876',
            labelcz: 'Insurance Authority',
            labelen: 'Insurance Authority'
        }
    ],
    FM: [
        {
            value: 'RA000186',
            labelcz: 'Registrar of Corporations',
            labelen: 'Registrar of Corporations'
        },
        {
            value: 'RA000948',
            labelcz: 'Banking Board of the Federated States of Micronesia',
            labelen: 'Banking Board of the Federated States of Micronesia'
        }
    ],
    FJ: [
        {
            value: 'RA000187',
            labelcz: 'Companies and Business Names Registry (Ministry of Finance)',
            labelen: 'Companies and Business Names Registry (Ministry of Finance)'
        },
        {
            value: 'RA000877',
            labelcz: 'Reserve Bank of Fiji',
            labelen: 'Reserve Bank of Fiji'
        }
    ],
    FI: [
        {
            value: 'RA000188',
            labelcz: 'The Business Information System (BIS)',
            labelen: 'The Business Information System (BIS)'
        },
        {
            value: 'RA000878',
            labelcz: 'Financial Supervisory Authority',
            labelen: 'Financial Supervisory Authority'
        }
    ],
    FR: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000190',
            labelcz: 'Autorité des marchés financiers',
            labelen: 'Autorité des marchés financiers'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        },
        {
            value: 'RA000879',
            labelcz: 'Autorité de Contrôle Prudentiel et de Résolution; Banque de France',
            labelen: 'Autorité de Contrôle Prudentiel et de Résolution; Banque de France'
        }
    ],
    GF: [
        {
            value: 'RA000189',
            labelcz: 'National Institute of Statistics and Economic Studies',
            labelen: 'National Institute of Statistics and Economic Studies'
        },
        {
            value: 'RA000192',
            labelcz: 'Infogreffe',
            labelen: 'Infogreffe'
        }
    ],
    PF: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        }
    ],
    GA: [
        {
            value: 'RA000193',
            labelcz: 'Registre du Commerce et du Crédit Mobilier (RCCM)',
            labelen: 'Registre du Commerce et du Crédit Mobilier (RCCM)'
        },
        {
            value: 'RA000829',
            labelcz: 'Bank of Central African States (BEAC)',
            labelen: 'Bank of Central African States (BEAC)'
        }
    ],
    GM: [
        {
            value: 'RA000195',
            labelcz: 'Companies Register (Ministry of Justice)',
            labelen: 'Companies Register (Ministry of Justice)'
        },
        {
            value: 'RA000880',
            labelcz: 'Central Bank of The Gambia',
            labelen: 'Central Bank of The Gambia'
        }
    ],
    GE: [
        {
            value: 'RA000196',
            labelcz: 'National Agency of Public Registry (Ministry of Justice of Georgia)',
            labelen: 'National Agency of Public Registry (Ministry of Justice of Georgia)'
        },
        {
            value: 'RA000881',
            labelcz: 'National Bank of Georgia',
            labelen: 'National Bank of Georgia'
        }
    ],
    DE: [
        {
            value: 'RA000197',
            labelcz: 'Commercial Register - Local Court Aachen',
            labelen: 'Commercial Register - Local Court Aachen'
        },
        {
            value: 'RA000199',
            labelcz: 'Commercial Register - Local Court Altenburg',
            labelen: 'Commercial Register - Local Court Altenburg'
        },
        {
            value: 'RA000200',
            labelcz: 'Commercial Register - Local Court Amberg',
            labelen: 'Commercial Register - Local Court Amberg'
        },
        {
            value: 'RA000201',
            labelcz: 'Commercial Register - Local Court Ansbach',
            labelen: 'Commercial Register - Local Court Ansbach'
        },
        {
            value: 'RA000202',
            labelcz: 'Commercial Register - Local Court Apolda',
            labelen: 'Commercial Register - Local Court Apolda'
        },
        {
            value: 'RA000203',
            labelcz: 'Commercial Register - Local Court Arnsberg',
            labelen: 'Commercial Register - Local Court Arnsberg'
        },
        {
            value: 'RA000204',
            labelcz: 'Commercial Register - Local Court Arnstadt',
            labelen: 'Commercial Register - Local Court Arnstadt'
        },
        {
            value: 'RA000205',
            labelcz: 'Commercial Register - Local Court Aschaffenburg',
            labelen: 'Commercial Register - Local Court Aschaffenburg'
        },
        {
            value: 'RA000206',
            labelcz: 'Commercial Register - Local Court Augsburg',
            labelen: 'Commercial Register - Local Court Augsburg'
        },
        {
            value: 'RA000207',
            labelcz: 'Commercial Register - Local Court Aurich',
            labelen: 'Commercial Register - Local Court Aurich'
        },
        {
            value: 'RA000208',
            labelcz: 'Commercial Register - Local Court Bad Hersfeld',
            labelen: 'Commercial Register - Local Court Bad Hersfeld'
        },
        {
            value: 'RA000209',
            labelcz: 'Commercial Register - Local Court Bad Homburg v. d. Höhe',
            labelen: 'Commercial Register - Local Court Bad Homburg v. d. Höhe'
        },
        {
            value: 'RA000210',
            labelcz: 'Commercial Register - Local Court Bad Kreuznach',
            labelen: 'Commercial Register - Local Court Bad Kreuznach'
        },
        {
            value: 'RA000213',
            labelcz: 'Commercial Register - Local Court Bad Oeynhausen',
            labelen: 'Commercial Register - Local Court Bad Oeynhausen'
        },
        {
            value: 'RA000214',
            labelcz: 'Commercial Register - Local Court Bad Salzungen',
            labelen: 'Commercial Register - Local Court Bad Salzungen'
        },
        {
            value: 'RA000215',
            labelcz: 'Commercial Register - Local Court Bamberg',
            labelen: 'Commercial Register - Local Court Bamberg'
        },
        {
            value: 'RA000704',
            labelcz: 'Foundations Directory - Bavarian State Office of Statistics',
            labelen: 'Foundations Directory - Bavarian State Office of Statistics'
        },
        {
            value: 'RA000216',
            labelcz: 'Commercial Register - Local Court Bayreuth',
            labelen: 'Commercial Register - Local Court Bayreuth'
        },
        {
            value: 'RA000217',
            labelcz: 'Commercial Register - Local Court Berlin-Charlottenburg',
            labelen: 'Commercial Register - Local Court Berlin-Charlottenburg'
        },
        {
            value: 'RA000727',
            labelcz:
                'Foundations Directory - Senate Department for Justice, Consumer Protection and Anti-discrimination',
            labelen:
                'Foundations Directory - Senate Department for Justice, Consumer Protection and Anti-discrimination'
        },
        {
            value: 'RA000218',
            labelcz: 'Commercial Register - Local Court Bielefeld',
            labelen: 'Commercial Register - Local Court Bielefeld'
        },
        {
            value: 'RA000219',
            labelcz: 'Commercial Register - Local Court Bochum',
            labelen: 'Commercial Register - Local Court Bochum'
        },
        {
            value: 'RA000220',
            labelcz: 'Commercial Register - Local Court Bonn',
            labelen: 'Commercial Register - Local Court Bonn'
        },
        {
            value: 'RA000733',
            labelcz: 'Foundations Directory - Brandenburgian Ministry of the Interior',
            labelen: 'Foundations Directory - Brandenburgian Ministry of the Interior'
        },
        {
            value: 'RA000221',
            labelcz: 'Commercial Register - Local Court Braunschweig',
            labelen: 'Commercial Register - Local Court Braunschweig'
        },
        {
            value: 'RA000772',
            labelcz: 'Foundations Directory - Regional Development Office Braunschweig',
            labelen: 'Foundations Directory - Regional Development Office Braunschweig'
        },
        {
            value: 'RA000222',
            labelcz: 'Commercial Register - Local Court Bremen',
            labelen: 'Commercial Register - Local Court Bremen'
        },
        {
            value: 'RA000742',
            labelcz: 'Foundations Directory - Senator for the interior',
            labelen: 'Foundations Directory - Senator for the interior'
        },
        {
            value: 'RA000224',
            labelcz: 'Commercial Register - Local Court Chemnitz',
            labelen: 'Commercial Register - Local Court Chemnitz'
        },
        {
            value: 'RA000225',
            labelcz: 'Commercial Register - Local Court Coburg',
            labelen: 'Commercial Register - Local Court Coburg'
        },
        {
            value: 'RA000226',
            labelcz: 'Commercial Register - Local Court Coesfeld',
            labelen: 'Commercial Register - Local Court Coesfeld'
        },
        {
            value: 'RA000227',
            labelcz: 'Commercial Register - Local Court Cottbus',
            labelen: 'Commercial Register - Local Court Cottbus'
        },
        {
            value: 'RA000233',
            labelcz: 'Commercial Register - Local Court Düren',
            labelen: 'Commercial Register - Local Court Düren'
        },
        {
            value: 'RA000234',
            labelcz: 'Commercial Register - Local Court Düsseldorf',
            labelen: 'Commercial Register - Local Court Düsseldorf'
        },
        {
            value: 'RA000228',
            labelcz: 'Commercial Register - Local Court Darmstadt',
            labelen: 'Commercial Register - Local Court Darmstadt'
        },
        {
            value: 'RA000229',
            labelcz: 'Commercial Register - Local Court Deggendorf',
            labelen: 'Commercial Register - Local Court Deggendorf'
        },
        {
            value: 'RA000230',
            labelcz: 'Commercial Register - Local Court Dortmund',
            labelen: 'Commercial Register - Local Court Dortmund'
        },
        {
            value: 'RA000712',
            labelcz: 'Foundations Directory - Wirtschaftsförderung Dortmund',
            labelen: 'Foundations Directory - Wirtschaftsförderung Dortmund'
        },
        {
            value: 'RA000231',
            labelcz: 'Commercial Register - Local Court Dresden',
            labelen: 'Commercial Register - Local Court Dresden'
        },
        {
            value: 'RA000232',
            labelcz: 'Commercial Register - Local Court Duisburg',
            labelen: 'Commercial Register - Local Court Duisburg'
        },
        {
            value: 'RA000235',
            labelcz: 'Commercial Register - Local Court Eisenach',
            labelen: 'Commercial Register - Local Court Eisenach'
        },
        {
            value: 'RA000236',
            labelcz: 'Commercial Register - Local Court Erfurt',
            labelen: 'Commercial Register - Local Court Erfurt'
        },
        {
            value: 'RA000238',
            labelcz: 'Commercial Register - Local Court Eschwege ',
            labelen: 'Commercial Register - Local Court Eschwege '
        },
        {
            value: 'RA000239',
            labelcz: 'Commercial Register - Local Court Essen',
            labelen: 'Commercial Register - Local Court Essen'
        },
        {
            value: 'RA000247',
            labelcz: 'Commercial Register - Local Court Fürth',
            labelen: 'Commercial Register - Local Court Fürth'
        },
        {
            value: 'RA000240',
            labelcz: 'Commercial Register - Local Court Flensburg',
            labelen: 'Commercial Register - Local Court Flensburg'
        },
        {
            value: 'RA000241',
            labelcz: 'Commercial Register - Local Court Frankfurt (Oder)',
            labelen: 'Commercial Register - Local Court Frankfurt (Oder)'
        },
        {
            value: 'RA000242',
            labelcz: 'Commercial Register - Local Court Frankfurt am Main',
            labelen: 'Commercial Register - Local Court Frankfurt am Main'
        },
        {
            value: 'RA000243',
            labelcz: 'Commercial Register - Local Court Freiburg',
            labelen: 'Commercial Register - Local Court Freiburg'
        },
        {
            value: 'RA000770',
            labelcz: 'Foundations Directory - Administrative Region Freiburg',
            labelen: 'Foundations Directory - Administrative Region Freiburg'
        },
        {
            value: 'RA000244',
            labelcz: 'Commercial Register - Local Court Friedberg (Hessen)',
            labelen: 'Commercial Register - Local Court Friedberg (Hessen)'
        },
        {
            value: 'RA000245',
            labelcz: 'Commercial Register - Local Court Fritzlar',
            labelen: 'Commercial Register - Local Court Fritzlar'
        },
        {
            value: 'RA000246',
            labelcz: 'Commercial Register - Local Court Fulda',
            labelen: 'Commercial Register - Local Court Fulda'
        },
        {
            value: 'RA000253',
            labelcz: 'Commercial Register- Local Court Göttingen',
            labelen: 'Commercial Register- Local Court Göttingen'
        },
        {
            value: 'RA000257',
            labelcz: 'Commercial Register - Local Court Gütersloh',
            labelen: 'Commercial Register - Local Court Gütersloh'
        },
        {
            value: 'RA000249',
            labelcz: 'Commercial Register - Local Court Gelsenkirchen',
            labelen: 'Commercial Register - Local Court Gelsenkirchen'
        },
        {
            value: 'RA000250',
            labelcz: 'Commercial Register - Local Court Gera',
            labelen: 'Commercial Register - Local Court Gera'
        },
        {
            value: 'RA000372',
            labelcz: 'Company Register - Bundesanzeiger',
            labelen: 'Company Register - Bundesanzeiger'
        },
        {
            value: 'RA000373',
            labelcz: 'Federal Financial Supervisory Authority',
            labelen: 'Federal Financial Supervisory Authority'
        },
        {
            value: 'RA000663',
            labelcz: 'Federal Statistical Office',
            labelen: 'Federal Statistical Office'
        },
        {
            value: 'RA000764',
            labelcz: 'Official Nationwide Register Of Lawyers - Federal Bar Association',
            labelen: 'Official Nationwide Register Of Lawyers - Federal Bar Association'
        },
        {
            value: 'RA000765',
            labelcz: 'Official directory of tax advisors - Federal Chamber of Tax Consultants',
            labelen: 'Official directory of tax advisors - Federal Chamber of Tax Consultants'
        },
        {
            value: 'RA000766',
            labelcz: 'Register of Statutory Auditors - Central Chamber of Public Accountants',
            labelen: 'Register of Statutory Auditors - Central Chamber of Public Accountants'
        },
        {
            value: 'RA000251',
            labelcz: 'Commercial Register - Local Court Gießen',
            labelen: 'Commercial Register - Local Court Gießen'
        },
        {
            value: 'RA000252',
            labelcz: 'Commercial Register - Local Court Gotha',
            labelen: 'Commercial Register - Local Court Gotha'
        },
        {
            value: 'RA000255',
            labelcz: 'Commercial Register - Local Court Greiz',
            labelen: 'Commercial Register - Local Court Greiz'
        },
        {
            value: 'RA000258',
            labelcz: 'Commercial Register - Local Court Hagen',
            labelen: 'Commercial Register - Local Court Hagen'
        },
        {
            value: 'RA000259',
            labelcz: 'Commercial Register - Local Court Hamburg',
            labelen: 'Commercial Register - Local Court Hamburg'
        },
        {
            value: 'RA000738',
            labelcz: 'Foundations Directory - Hamburg Service Portal',
            labelen: 'Foundations Directory - Hamburg Service Portal'
        },
        {
            value: 'RA000260',
            labelcz: 'Commercial Register - Local Court Hamm',
            labelen: 'Commercial Register - Local Court Hamm'
        },
        {
            value: 'RA000261',
            labelcz: 'Commercial Register - Local Court Hanau',
            labelen: 'Commercial Register - Local Court Hanau'
        },
        {
            value: 'RA000262',
            labelcz: 'Commercial Register - Local Court Hannover ',
            labelen: 'Commercial Register - Local Court Hannover '
        },
        {
            value: 'RA000263',
            labelcz: 'Commercial Register - Local Court Heilbad Heiligenstadt',
            labelen: 'Commercial Register - Local Court Heilbad Heiligenstadt'
        },
        {
            value: 'RA000722',
            labelcz: 'Foundations Directory - Hessian Ministry of the Interior and Sports',
            labelen: 'Foundations Directory - Hessian Ministry of the Interior and Sports'
        },
        {
            value: 'RA000266',
            labelcz: 'Commercial Register - Local Court Hildburghausen',
            labelen: 'Commercial Register - Local Court Hildburghausen'
        },
        {
            value: 'RA000267',
            labelcz: 'Commercial Register - Local Court Hildesheim',
            labelen: 'Commercial Register - Local Court Hildesheim'
        },
        {
            value: 'RA000268',
            labelcz: 'Commercial Register - Local Court Hof',
            labelen: 'Commercial Register - Local Court Hof'
        },
        {
            value: 'RA000269',
            labelcz: 'Commercial Register - Local Court Homburg',
            labelen: 'Commercial Register - Local Court Homburg'
        },
        {
            value: 'RA000271',
            labelcz: 'Commercial Register - Local Court Ingolstadt',
            labelen: 'Commercial Register - Local Court Ingolstadt'
        },
        {
            value: 'RA000272',
            labelcz: 'Commercial Register - Local Court Iserlohn',
            labelen: 'Commercial Register - Local Court Iserlohn'
        },
        {
            value: 'RA000273',
            labelcz: 'Commercial Register - Local Court Jena',
            labelen: 'Commercial Register - Local Court Jena'
        },
        {
            value: 'RA000280',
            labelcz: 'Commercial Register - Local Court Köln',
            labelen: 'Commercial Register - Local Court Köln'
        },
        {
            value: 'RA000281',
            labelcz: 'Commercial Register - Local Court Königstein im Taunus',
            labelen: 'Commercial Register - Local Court Königstein im Taunus'
        },
        {
            value: 'RA000274',
            labelcz: 'Commercial Register - Local Court Kaiserslautern',
            labelen: 'Commercial Register - Local Court Kaiserslautern'
        },
        {
            value: 'RA000769',
            labelcz: 'Foundations Directory - Administrative Region Karlsruhe',
            labelen: 'Foundations Directory - Administrative Region Karlsruhe'
        },
        {
            value: 'RA000275',
            labelcz: 'Commercial Register - Local Court Kassel',
            labelen: 'Commercial Register - Local Court Kassel'
        },
        {
            value: 'RA000276',
            labelcz: 'Commercial Register - Local Court Kempten',
            labelen: 'Commercial Register - Local Court Kempten'
        },
        {
            value: 'RA000277',
            labelcz: 'Commercial Register - Local Court Kiel',
            labelen: 'Commercial Register - Local Court Kiel'
        },
        {
            value: 'RA000278',
            labelcz: 'Commercial Register - Local Court Kleve',
            labelen: 'Commercial Register - Local Court Kleve'
        },
        {
            value: 'RA000279',
            labelcz: 'Commercial Register - Local Court Koblenz',
            labelen: 'Commercial Register - Local Court Koblenz'
        },
        {
            value: 'RA000282',
            labelcz: 'Commercial Register - Local Court Korbach',
            labelen: 'Commercial Register - Local Court Korbach'
        },
        {
            value: 'RA000283',
            labelcz: 'Commercial Register - Local Court Krefeld',
            labelen: 'Commercial Register - Local Court Krefeld'
        },
        {
            value: 'RA000290',
            labelcz: 'Commercial Register - Local Court Lübeck',
            labelen: 'Commercial Register - Local Court Lübeck'
        },
        {
            value: 'RA000293',
            labelcz: 'Commercial Register - Local Court Lüneburg',
            labelen: 'Commercial Register - Local Court Lüneburg'
        },
        {
            value: 'RA000774',
            labelcz: 'Foundations Directory - Regional Development Office Lüneburg',
            labelen: 'Foundations Directory - Regional Development Office Lüneburg'
        },
        {
            value: 'RA000284',
            labelcz: 'Commercial Register - Local Court Landau in der Pfalz',
            labelen: 'Commercial Register - Local Court Landau in der Pfalz'
        },
        {
            value: 'RA000285',
            labelcz: 'Commercial Register - Local Court Landshut',
            labelen: 'Commercial Register - Local Court Landshut'
        },
        {
            value: 'RA000286',
            labelcz: 'Commercial Register - Local Court Lebach',
            labelen: 'Commercial Register - Local Court Lebach'
        },
        {
            value: 'RA000773',
            labelcz: 'Foundations Directory - Regional Development Office Leine Weser',
            labelen: 'Foundations Directory - Regional Development Office Leine Weser'
        },
        {
            value: 'RA000287',
            labelcz: 'Commercial Register - Local Court Leipzig',
            labelen: 'Commercial Register - Local Court Leipzig'
        },
        {
            value: 'RA000288',
            labelcz: 'Commercial Register - Local Court Lemgo ',
            labelen: 'Commercial Register - Local Court Lemgo '
        },
        {
            value: 'RA000289',
            labelcz: 'Commercial Register - Local Court Limburg a. d. Lahn',
            labelen: 'Commercial Register - Local Court Limburg a. d. Lahn'
        },
        {
            value: 'RA000291',
            labelcz: 'Commercial Register - Local Court Ludwigshafen am Rhein',
            labelen: 'Commercial Register - Local Court Ludwigshafen am Rhein'
        },
        {
            value: 'RA000301',
            labelcz: 'Commercial Register - Local Court Mönchengladbach',
            labelen: 'Commercial Register - Local Court Mönchengladbach'
        },
        {
            value: 'RA000303',
            labelcz: 'Commercial Register - Local Court Mühlhausen',
            labelen: 'Commercial Register - Local Court Mühlhausen'
        },
        {
            value: 'RA000304',
            labelcz: 'Commercial Register - Local Court München',
            labelen: 'Commercial Register - Local Court München'
        },
        {
            value: 'RA000305',
            labelcz: 'Commercial Register - Local Court Münster',
            labelen: 'Commercial Register - Local Court Münster'
        },
        {
            value: 'RA000295',
            labelcz: 'Commercial Register - Local Court Mainz',
            labelen: 'Commercial Register - Local Court Mainz'
        },
        {
            value: 'RA000296',
            labelcz: 'Commercial Register - Local Court Mannheim',
            labelen: 'Commercial Register - Local Court Mannheim'
        },
        {
            value: 'RA000297',
            labelcz: 'Commercial Register - Local Court Marburg',
            labelen: 'Commercial Register - Local Court Marburg'
        },
        {
            value: 'RA000743',
            labelcz: 'Foundations Directory - Ministry of Justice',
            labelen: 'Foundations Directory - Ministry of Justice'
        },
        {
            value: 'RA000298',
            labelcz: 'Commercial Register - Local Court Meiningen',
            labelen: 'Commercial Register - Local Court Meiningen'
        },
        {
            value: 'RA000299',
            labelcz: 'Commercial Register - Local Court Memmingen',
            labelen: 'Commercial Register - Local Court Memmingen'
        },
        {
            value: 'RA000300',
            labelcz: 'Commercial Register - Local Court Merzig',
            labelen: 'Commercial Register - Local Court Merzig'
        },
        {
            value: 'RA000302',
            labelcz: 'Commercial Register - Local Court Montabaur',
            labelen: 'Commercial Register - Local Court Montabaur'
        },
        {
            value: 'RA000311',
            labelcz: 'Commercial Register - Local Court Nürnberg',
            labelen: 'Commercial Register - Local Court Nürnberg'
        },
        {
            value: 'RA000306',
            labelcz: 'Commercial Register - Local Court Neubrandenburg',
            labelen: 'Commercial Register - Local Court Neubrandenburg'
        },
        {
            value: 'RA000307',
            labelcz: 'Commercial Register - Local Court Neunkirchen',
            labelen: 'Commercial Register - Local Court Neunkirchen'
        },
        {
            value: 'RA000308',
            labelcz: 'Commercial Register - Local Court Neuruppin',
            labelen: 'Commercial Register - Local Court Neuruppin'
        },
        {
            value: 'RA000309',
            labelcz: 'Commercial Register - Local Court Neuss',
            labelen: 'Commercial Register - Local Court Neuss'
        },
        {
            value: 'RA000310',
            labelcz: 'Commercial Register - Local Court Nordhausen',
            labelen: 'Commercial Register - Local Court Nordhausen'
        },
        {
            value: 'RA000711',
            labelcz: 'Foundations Directory - Ministry of the Interior of North Rhine-Westphalia',
            labelen: 'Foundations Directory - Ministry of the Interior of North Rhine-Westphalia'
        },
        {
            value: 'RA000313',
            labelcz: 'Commercial Register - Local Court Offenbach am Main',
            labelen: 'Commercial Register - Local Court Offenbach am Main'
        },
        {
            value: 'RA000314',
            labelcz: 'Commercial Register - Local Court Oldenburg',
            labelen: 'Commercial Register - Local Court Oldenburg'
        },
        {
            value: 'RA000315',
            labelcz: 'Commercial Register - Local Court Osnabrück',
            labelen: 'Commercial Register - Local Court Osnabrück'
        },
        {
            value: 'RA000316',
            labelcz: 'Commercial Register - Local Court Ottweiler',
            labelen: 'Commercial Register - Local Court Ottweiler'
        },
        {
            value: 'RA000321',
            labelcz: 'Commercial Register - Local Court Pößneck',
            labelen: 'Commercial Register - Local Court Pößneck'
        },
        {
            value: 'RA000317',
            labelcz: 'Commercial Register - Local Court Paderborn',
            labelen: 'Commercial Register - Local Court Paderborn'
        },
        {
            value: 'RA000319',
            labelcz: 'Commercial Register - Local Court Passau',
            labelen: 'Commercial Register - Local Court Passau'
        },
        {
            value: 'RA000320',
            labelcz: 'Commercial Register - Local Court Pinneberg',
            labelen: 'Commercial Register - Local Court Pinneberg'
        },
        {
            value: 'RA000322',
            labelcz: 'Commercial Register - Local Court Potsdam',
            labelen: 'Commercial Register - Local Court Potsdam'
        },
        {
            value: 'RA000324',
            labelcz: 'Commercial Register - Local Court Recklinghausen',
            labelen: 'Commercial Register - Local Court Recklinghausen'
        },
        {
            value: 'RA000325',
            labelcz: 'Commercial Register -Local Court Regensburg',
            labelen: 'Commercial Register -Local Court Regensburg'
        },
        {
            value: 'RA000737',
            labelcz: 'Foundations Directory - Supervision and Services Directorate of Rhineland-Palatinate',
            labelen: 'Foundations Directory - Supervision and Services Directorate of Rhineland-Palatinate'
        },
        {
            value: 'RA000328',
            labelcz: 'Commercial Register - Local Court Rostock',
            labelen: 'Commercial Register - Local Court Rostock'
        },
        {
            value: 'RA000329',
            labelcz: 'Commercial Register - Local Court Rudolstadt',
            labelen: 'Commercial Register - Local Court Rudolstadt'
        },
        {
            value: 'RA000342',
            labelcz: 'Commercial Register - Local Court Sömmerda',
            labelen: 'Commercial Register - Local Court Sömmerda'
        },
        {
            value: 'RA000331',
            labelcz: 'Commercial Register - Local Court Saarbrücken',
            labelen: 'Commercial Register - Local Court Saarbrücken'
        },
        {
            value: 'RA000741',
            labelcz: 'Foundations Directory - Ministry for Internal Affairs, Construction and Sport',
            labelen: 'Foundations Directory - Ministry for Internal Affairs, Construction and Sport'
        },
        {
            value: 'RA000332',
            labelcz: 'Commercial Register - Local Court Saarlouis',
            labelen: 'Commercial Register - Local Court Saarlouis'
        },
        {
            value: 'RA000333',
            labelcz: 'Commercial Register - Local Court Sankt Ingbert',
            labelen: 'Commercial Register - Local Court Sankt Ingbert'
        },
        {
            value: 'RA000334',
            labelcz: 'Commercial Register - Local Court Sankt Wendel',
            labelen: 'Commercial Register - Local Court Sankt Wendel'
        },
        {
            value: 'RA000740',
            labelcz: 'Foundations Directory - State Administration',
            labelen: 'Foundations Directory - State Administration'
        },
        {
            value: 'RA000739',
            labelcz: 'Foundations Directory - State Directorate of Saxony',
            labelen: 'Foundations Directory - State Directorate of Saxony'
        },
        {
            value: 'RA000723',
            labelcz: 'Foundations Directory - State Government',
            labelen: 'Foundations Directory - State Government'
        },
        {
            value: 'RA000336',
            labelcz: 'Commercial Register - Local Court Schweinfurt',
            labelen: 'Commercial Register - Local Court Schweinfurt'
        },
        {
            value: 'RA000337',
            labelcz: 'Commercial Register - Local Court Schwerin',
            labelen: 'Commercial Register - Local Court Schwerin'
        },
        {
            value: 'RA000338',
            labelcz: 'Commercial Register - Local Court Siegburg',
            labelen: 'Commercial Register - Local Court Siegburg'
        },
        {
            value: 'RA000339',
            labelcz: 'Commercial Register - Local Court Siegen',
            labelen: 'Commercial Register - Local Court Siegen'
        },
        {
            value: 'RA000343',
            labelcz: 'Commercial Register - Local Court Sondershausen',
            labelen: 'Commercial Register - Local Court Sondershausen'
        },
        {
            value: 'RA000344',
            labelcz: 'Commercial Register - Local Court Sonneberg',
            labelen: 'Commercial Register - Local Court Sonneberg'
        },
        {
            value: 'RA000345',
            labelcz: 'Commercial Register - Local Court Stadthagen',
            labelen: 'Commercial Register - Local Court Stadthagen'
        },
        {
            value: 'RA000346',
            labelcz: 'Commercial Register - Local Court Stadtroda',
            labelen: 'Commercial Register - Local Court Stadtroda'
        },
        {
            value: 'RA000347',
            labelcz: 'Commercial Register - Local Court Steinfurt',
            labelen: 'Commercial Register - Local Court Steinfurt'
        },
        {
            value: 'RA000348',
            labelcz: 'Commercial Register - Local Court Stendal',
            labelen: 'Commercial Register - Local Court Stendal'
        },
        {
            value: 'RA000349',
            labelcz: 'Commercial Register - Local Court Stralsund',
            labelen: 'Commercial Register - Local Court Stralsund'
        },
        {
            value: 'RA000350',
            labelcz: 'Commercial Register - Local Court Straubing',
            labelen: 'Commercial Register - Local Court Straubing'
        },
        {
            value: 'RA000351',
            labelcz: 'Commercial Register - Local Court Stuttgart',
            labelen: 'Commercial Register - Local Court Stuttgart'
        },
        {
            value: 'RA000768',
            labelcz: 'Foundations Directory - Administrative Region Stuttgart',
            labelen: 'Foundations Directory - Administrative Region Stuttgart'
        },
        {
            value: 'RA000352',
            labelcz: 'Commercial Register - Local Court Suhl',
            labelen: 'Commercial Register - Local Court Suhl'
        },
        {
            value: 'RA000771',
            labelcz: 'Foundations Directory - Administrative Region Tübingen',
            labelen: 'Foundations Directory - Administrative Region Tübingen'
        },
        {
            value: 'RA000736',
            labelcz: 'Foundations Directory - Thuringia State Administration',
            labelen: 'Foundations Directory - Thuringia State Administration'
        },
        {
            value: 'RA000353',
            labelcz: 'Commercial Register - Local Court Tostedt',
            labelen: 'Commercial Register - Local Court Tostedt'
        },
        {
            value: 'RA000354',
            labelcz: 'Commercial Register - Local Court Traunstein',
            labelen: 'Commercial Register - Local Court Traunstein'
        },
        {
            value: 'RA000355',
            labelcz: 'Commercial Register - Local Court Ulm',
            labelen: 'Commercial Register - Local Court Ulm'
        },
        {
            value: 'RA000356',
            labelcz: 'Commercial Register - Local Court Völklingen',
            labelen: 'Commercial Register - Local Court Völklingen'
        },
        {
            value: 'RA000370',
            labelcz: 'Commercial Register - Local Court Würzburg',
            labelen: 'Commercial Register - Local Court Würzburg'
        },
        {
            value: 'RA000358',
            labelcz: 'Commercial Register - Local Court Walsrode',
            labelen: 'Commercial Register - Local Court Walsrode'
        },
        {
            value: 'RA000362',
            labelcz: 'Commercial Register - Local Court Weiden i.d. OPf.',
            labelen: 'Commercial Register - Local Court Weiden i.d. OPf.'
        },
        {
            value: 'RA000363',
            labelcz: 'Commercial Register - Local Court Weimar',
            labelen: 'Commercial Register - Local Court Weimar'
        },
        {
            value: 'RA000775',
            labelcz: 'Foundations Directory - Regional Development Office Weser-Ems',
            labelen: 'Foundations Directory - Regional Development Office Weser-Ems'
        },
        {
            value: 'RA000364',
            labelcz: 'Commercial Register - Local Court Wetzlar',
            labelen: 'Commercial Register - Local Court Wetzlar'
        },
        {
            value: 'RA000365',
            labelcz: 'Commercial Register - Local Court Wiesbaden',
            labelen: 'Commercial Register - Local Court Wiesbaden'
        },
        {
            value: 'RA000368',
            labelcz: 'Commercial Register - Local Court Wittlich',
            labelen: 'Commercial Register - Local Court Wittlich'
        },
        {
            value: 'RA000369',
            labelcz: 'Commercial Register - Local Court Wuppertal',
            labelen: 'Commercial Register - Local Court Wuppertal'
        },
        {
            value: 'RA000371',
            labelcz: 'Commercial Register - Local Court Zweibrücken',
            labelen: 'Commercial Register - Local Court Zweibrücken'
        },
        {
            value: 'RA001076',
            labelcz: 'Verzeichnis der Parteien',
            labelen: 'Verzeichnis der Parteien'
        }
    ],
    GH: [
        {
            value: 'RA000374',
            labelcz: "Registrar General's Department",
            labelen: "Registrar General's Department"
        },
        {
            value: 'RA000882',
            labelcz: 'Securities and Exchange Commission Ghana',
            labelen: 'Securities and Exchange Commission Ghana'
        }
    ],
    GI: [
        {
            value: 'RA000375',
            labelcz: 'Companies House Gibraltar',
            labelen: 'Companies House Gibraltar'
        },
        {
            value: 'RA000883',
            labelcz: 'Gibraltar Financial Services Commission',
            labelen: 'Gibraltar Financial Services Commission'
        }
    ],
    GR: [
        {
            value: 'RA000376',
            labelcz: 'Athens Chamber of Commerce and Industry + Offcial Gazette',
            labelen: 'Athens Chamber of Commerce and Industry + Offcial Gazette'
        },
        {
            value: 'RA000377',
            labelcz: 'Hellenic Capital Market Commission',
            labelen: 'Hellenic Capital Market Commission'
        },
        {
            value: 'RA000685',
            labelcz: 'General Commercial Registry (G.E.MI.)',
            labelen: 'General Commercial Registry (G.E.MI.)'
        },
        {
            value: 'RA001115',
            labelcz: 'National Printing House',
            labelen: 'National Printing House'
        },
        {
            value: 'RA001118',
            labelcz: 'Register of Shipping Companies of Pleasure Vessels',
            labelen: 'Register of Shipping Companies of Pleasure Vessels'
        }
    ],
    GL: [
        {
            value: 'RA000378',
            labelcz: 'Central Business Register',
            labelen: 'Central Business Register'
        },
        {
            value: 'RA000655',
            labelcz: 'Tax Agency',
            labelen: 'Tax Agency'
        }
    ],
    GD: [
        {
            value: 'RA000379',
            labelcz: 'Registrar of Companies and Intellectual Property (Supreme Courty Registry)',
            labelen: 'Registrar of Companies and Intellectual Property (Supreme Courty Registry)'
        },
        {
            value: 'RA000884',
            labelcz: 'Grenada Authority for the Regulation of Financial Institutions (GARFIN)',
            labelen: 'Grenada Authority for the Regulation of Financial Institutions (GARFIN)'
        }
    ],
    GP: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        }
    ],
    GU: [
        {
            value: 'RA000381',
            labelcz: 'Company Registry',
            labelen: 'Company Registry'
        },
        {
            value: 'RA000665',
            labelcz: 'Securities and Exchange Commission',
            labelen: 'Securities and Exchange Commission'
        },
        {
            value: 'RA000745',
            labelcz: 'Registry of federally insured credit unions',
            labelen: 'Registry of federally insured credit unions'
        }
    ],
    GT: [
        {
            value: 'RA000382',
            labelcz: 'Commerce Register of The Republic of Guatemala',
            labelen: 'Commerce Register of The Republic of Guatemala'
        },
        {
            value: 'RA000885',
            labelcz: 'Superintendencia de Bancos',
            labelen: 'Superintendencia de Bancos'
        },
        {
            value: 'RA001099',
            labelcz: 'Registro Tributario Unificado',
            labelen: 'Registro Tributario Unificado'
        }
    ],
    GG: [
        {
            value: 'RA000777',
            labelcz: 'Company Registry',
            labelen: 'Company Registry'
        },
        {
            value: 'RA000383',
            labelcz: 'Limited Companies Register',
            labelen: 'Limited Companies Register'
        },
        {
            value: 'RA000666',
            labelcz: 'Foundations Register',
            labelen: 'Foundations Register'
        },
        {
            value: 'RA000667',
            labelcz: 'Limited Partnerships Register',
            labelen: 'Limited Partnerships Register'
        },
        {
            value: 'RA000668',
            labelcz: 'Limited Liability Partnerships Register',
            labelen: 'Limited Liability Partnerships Register'
        },
        {
            value: 'RA000886',
            labelcz: 'Guernsey Financial Services Commission (GFSC)',
            labelen: 'Guernsey Financial Services Commission (GFSC)'
        }
    ],
    GN: [
        {
            value: 'RA000384',
            labelcz: 'RA000384',
            labelen: 'RA000384'
        },
        {
            value: 'RA000887',
            labelcz: 'Central Bank of the Republic of Guinea',
            labelen: 'Central Bank of the Republic of Guinea'
        }
    ],
    GY: [
        {
            value: 'RA000385',
            labelcz: 'Georgetown Chamber of Commerce & Industry',
            labelen: 'Georgetown Chamber of Commerce & Industry'
        },
        {
            value: 'RA000888',
            labelcz: 'Guyana Securities Council',
            labelen: 'Guyana Securities Council'
        },
        {
            value: 'RA000889',
            labelcz: 'Bank of Guyana',
            labelen: 'Bank of Guyana'
        }
    ],
    HT: [
        {
            value: 'RA000386',
            labelcz: 'Commerce Register - Ministry of Commerce and Industry',
            labelen: 'Commerce Register - Ministry of Commerce and Industry'
        },
        {
            value: 'RA000890',
            labelcz: 'Bank of the Republic of Haiti',
            labelen: 'Bank of the Republic of Haiti'
        }
    ],
    HN: [
        {
            value: 'RA000387',
            labelcz: 'Chamber of Commerce and Industry of Tegucigalpa',
            labelen: 'Chamber of Commerce and Industry of Tegucigalpa'
        },
        {
            value: 'RA000892',
            labelcz: 'Comisión Nacional de Bancos y Seguros',
            labelen: 'Comisión Nacional de Bancos y Seguros'
        },
        {
            value: 'RA000893',
            labelcz: 'Central Bank of Honduras',
            labelen: 'Central Bank of Honduras'
        },
        {
            value: 'RA001106',
            labelcz: 'Servicio de Administración de Rentas (SAR)',
            labelen: 'Servicio de Administración de Rentas (SAR)'
        }
    ],
    HK: [
        {
            value: 'RA000388',
            labelcz: 'Companies Registry',
            labelen: 'Companies Registry'
        },
        {
            value: 'RA000389',
            labelcz:
                'Business Registration Office of the Inland Revenue Department, The Government of the Hong Kong Special Administrative Region',
            labelen:
                'Business Registration Office of the Inland Revenue Department, The Government of the Hong Kong Special Administrative Region'
        },
        {
            value: 'RA000390',
            labelcz: 'Securities and Futures Commission',
            labelen: 'Securities and Futures Commission'
        },
        {
            value: 'RA000894',
            labelcz: 'Mandatory Provident Fund Schemes Authority',
            labelen: 'Mandatory Provident Fund Schemes Authority'
        },
        {
            value: 'RA001123',
            labelcz: 'List of Tax-Exempt Charities',
            labelen: 'List of Tax-Exempt Charities'
        }
    ],
    HU: [
        {
            value: 'RA000391',
            labelcz: 'National Company Register and Company Information System',
            labelen: 'National Company Register and Company Information System'
        },
        {
            value: 'RA000392',
            labelcz: 'Register of Financial Service Providers',
            labelen: 'Register of Financial Service Providers'
        },
        {
            value: 'RA000656',
            labelcz: 'Registry of civil society organisations',
            labelen: 'Registry of civil society organisations'
        },
        {
            value: 'RA000732',
            labelcz: 'Public Education Information System',
            labelen: 'Public Education Information System'
        },
        {
            value: 'RA000750',
            labelcz: 'National Lawyers Register',
            labelen: 'National Lawyers Register'
        },
        {
            value: 'RA000895',
            labelcz: 'Ministry of Interior',
            labelen: 'Ministry of Interior'
        },
        {
            value: 'RA000896',
            labelcz: 'Land Administration',
            labelen: 'Land Administration'
        },
        {
            value: 'RA000897',
            labelcz: 'State Treasury',
            labelen: 'State Treasury'
        },
        {
            value: 'RA001059',
            labelcz: 'Church Register',
            labelen: 'Church Register'
        },
        {
            value: 'RA001117',
            labelcz: 'National Tax and Customs',
            labelen: 'National Tax and Customs'
        },
        {
            value: 'RA001122',
            labelcz: 'Higher Education Information System',
            labelen: 'Higher Education Information System'
        }
    ],
    IS: [
        {
            value: 'RA000393',
            labelcz: 'Register of Enterprises',
            labelen: 'Register of Enterprises'
        },
        {
            value: 'RA000898',
            labelcz: 'Financial Supervisory Authority of the Central Bank',
            labelen: 'Financial Supervisory Authority of the Central Bank'
        }
    ],
    IN: [
        {
            value: 'RA000394',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA000395',
            labelcz: 'Securities Commission',
            labelen: 'Securities Commission'
        },
        {
            value: 'RA000396',
            labelcz: 'Housing Finance Company Regulator',
            labelen: 'Housing Finance Company Regulator'
        },
        {
            value: 'RA000397',
            labelcz: 'Tax Registry',
            labelen: 'Tax Registry'
        },
        {
            value: 'RA000398',
            labelcz: 'Bank Deposit Insurance Agency',
            labelen: 'Bank Deposit Insurance Agency'
        },
        {
            value: 'RA000399',
            labelcz: 'Government Gazette',
            labelen: 'Government Gazette'
        },
        {
            value: 'RA000697',
            labelcz: 'Register of National Securities Depository Limited',
            labelen: 'Register of National Securities Depository Limited'
        },
        {
            value: 'RA000708',
            labelcz: 'Distinctive Number Database',
            labelen: 'Distinctive Number Database'
        },
        {
            value: 'RA000709',
            labelcz: 'Database of Importer Exporter Code (IEC)',
            labelen: 'Database of Importer Exporter Code (IEC)'
        },
        {
            value: 'RA000713',
            labelcz: 'ICEGATE (Indian Customs Electronic Commerce/Electronic Data interchange (EC/EDI) Gateway)',
            labelen: 'ICEGATE (Indian Customs Electronic Commerce/Electronic Data interchange (EC/EDI) Gateway)'
        },
        {
            value: 'RA000717',
            labelcz: 'NGO Directory (NGO-DARPAN)',
            labelen: 'NGO Directory (NGO-DARPAN)'
        },
        {
            value: 'RA000754',
            labelcz: 'GST Portal',
            labelen: 'GST Portal'
        },
        {
            value: 'RA000778',
            labelcz: 'Financial Agents',
            labelen: 'Financial Agents'
        },
        {
            value: 'RA000900',
            labelcz: 'Ministry of Micro, Small Medium Enterprises',
            labelen: 'Ministry of Micro, Small Medium Enterprises'
        },
        {
            value: 'RA000901',
            labelcz: 'International Financial Services Centres Authority',
            labelen: 'International Financial Services Centres Authority'
        },
        {
            value: 'RA000902',
            labelcz: 'Registrar, Firms and Societies, Government of Madhya Pradesh',
            labelen: 'Registrar, Firms and Societies, Government of Madhya Pradesh'
        },
        {
            value: 'RA000903',
            labelcz: 'Registration and Stamps Department, Government of Telangana',
            labelen: 'Registration and Stamps Department, Government of Telangana'
        },
        {
            value: 'RA001081',
            labelcz: 'Food Safety Compliance System (FoSCoS)',
            labelen: 'Food Safety Compliance System (FoSCoS)'
        },
        {
            value: 'RA001095',
            labelcz: 'Income Tax Portal',
            labelen: 'Income Tax Portal'
        }
    ],
    ID: [
        {
            value: 'RA000400',
            labelcz: 'Company Directory - Ministry of Trade',
            labelen: 'Ministry of Trade'
        },
        {
            value: 'RA000763',
            labelcz:
                'Company Registry - Directorate General for Legal Administrative Affairs, Ministry of Law and Human Rights',
            labelen: 'Directorate General for Legal Administrative Affairs, Ministry of Law and Human Rights'
        },
        {
            value: 'RA000904',
            labelcz: 'Financial Services Authority',
            labelen: 'Financial Services Authority'
        },
        {
            value: 'RA001108',
            labelcz: 'Electronically Integrated Business Licensing System',
            labelen: 'Electronically Integrated Business Licensing System'
        }
    ],
    IR: [
        {
            value: 'RA000680',
            labelcz: 'Register for banks and credit institutions',
            labelen: 'Register for banks and credit institutions'
        },
        {
            value: 'RA000905',
            labelcz: 'Securities and Exchange Organization',
            labelen: 'Securities and Exchange Organization'
        },
        {
            value: 'RA000906',
            labelcz: 'Iraqi Securities Commission (ISC)',
            labelen: 'Iraqi Securities Commission (ISC)'
        }
    ],
    IQ: [
        {
            value: 'RA000401',
            labelcz: 'Registrar of Companies',
            labelen: 'Registrar of Companies'
        },
        {
            value: 'RA000907',
            labelcz: 'Central Bank of Iraq',
            labelen: 'Central Bank of Iraq'
        }
    ],
    IE: [
        {
            value: 'RA000402',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA000403',
            labelcz: 'Registry of Friendly Societies',
            labelen: 'Registry of Friendly Societies'
        },
        {
            value: 'RA000404',
            labelcz: 'Registers for financial service providers and collective investment schemes',
            labelen: 'Registers for financial service providers and collective investment schemes'
        },
        {
            value: 'RA000700',
            labelcz: 'Charities Register',
            labelen: 'Charities Register'
        }
    ],
    IM: [
        {
            value: 'RA000405',
            labelcz: 'Companies Registry',
            labelen: 'Companies Registry'
        },
        {
            value: 'RA000908',
            labelcz: 'Isle of Man Financial Services Authority',
            labelen: 'Isle of Man Financial Services Authority'
        }
    ],
    IL: [
        {
            value: 'RA000406',
            labelcz: 'Israeli Corporations Authority (Department of Justice)',
            labelen: 'Israeli Corporations Authority (Department of Justice)'
        },
        {
            value: 'RA000909',
            labelcz: 'Israel Securities Authority',
            labelen: 'Israel Securities Authority'
        },
        {
            value: 'RA001045',
            labelcz: 'Government ICT Authority',
            labelen: 'Government ICT Authority'
        }
    ],
    IT: [
        {
            value: 'RA000407',
            labelcz: 'Business Register',
            labelen: 'Business Register'
        },
        {
            value: 'RA000408',
            labelcz: 'List of collective investment schemes (UCITS)',
            labelen: 'List of collective investment schemes (UCITS)'
        },
        {
            value: 'RA000409',
            labelcz: 'Commissione di vigilanza sui fondi pensione',
            labelen: 'Commissione di vigilanza sui fondi pensione'
        },
        {
            value: 'RA000410',
            labelcz: 'The Italian Companies and Stock Exchange Commission',
            labelen: 'The Italian Companies and Stock Exchange Commission'
        },
        {
            value: 'RA000699',
            labelcz: 'Index of Public Administrations (IPA)',
            labelen: 'Index of Public Administrations (IPA)'
        },
        {
            value: 'RA000776',
            labelcz: 'Tax Register Information System',
            labelen: 'Tax Register Information System'
        },
        {
            value: 'RA001087',
            labelcz: 'Registro Unico Nazionale Terzo Settore (RUNTS)',
            labelen: 'Registro Unico Nazionale Terzo Settore (RUNTS)'
        }
    ],
    JM: [
        {
            value: 'RA000411',
            labelcz: 'Companies Office of Jamaica',
            labelen: 'Companies Office of Jamaica'
        },
        {
            value: 'RA000910',
            labelcz: 'Bank of Jamaica',
            labelen: 'Bank of Jamaica'
        },
        {
            value: 'RA000911',
            labelcz: 'Financial Services Commission (FSC)',
            labelen: 'Financial Services Commission (FSC)'
        }
    ],
    JP: [
        {
            value: 'RA000412',
            labelcz: 'Companies Registration',
            labelen: 'Companies Registration'
        },
        {
            value: 'RA000413',
            labelcz: 'Financial Services Agency',
            labelen: 'Financial Services Agency'
        },
        {
            value: 'RA000912',
            labelcz: 'Securities and Exchange Surveillance Commission',
            labelen: 'Securities and Exchange Surveillance Commission'
        },
        {
            value: 'RA001075',
            labelcz: 'Corporate Number Publication Site',
            labelen: 'Corporate Number Publication Site'
        }
    ],
    JE: [
        {
            value: 'RA000414',
            labelcz: 'Jersey Financial Services Commission Companies Registry',
            labelen: 'Jersey Financial Services Commission Companies Registry'
        },
        {
            value: 'RA000913',
            labelcz: 'Jersey Financial Services Commission',
            labelen: 'Jersey Financial Services Commission'
        }
    ],
    JO: [
        {
            value: 'RA000698',
            labelcz: 'Business Directory',
            labelen: 'Business Directory'
        },
        {
            value: 'RA000415',
            labelcz: 'Companies Control Department',
            labelen: 'Companies Control Department'
        },
        {
            value: 'RA000914',
            labelcz: 'Jordan Securities Commission',
            labelen: 'Jordan Securities Commission'
        }
    ],
    KZ: [
        {
            value: 'RA000416',
            labelcz: 'National Register of Business Identification Codes',
            labelen: 'National Register of Business Identification Codes'
        },
        {
            value: 'RA000915',
            labelcz: 'Information and Accounting Center, Ministry of Finance',
            labelen: 'Information and Accounting Center, Ministry of Finance'
        },
        {
            value: 'RA000916',
            labelcz: 'State Revenue Committee of the Ministry of Finance',
            labelen: 'State Revenue Committee of the Ministry of Finance'
        },
        {
            value: 'RA000917',
            labelcz: 'The Agency of the Republic of Kazakhstan for Regulation and Development of Financial Market',
            labelen: 'The Agency of the Republic of Kazakhstan for Regulation and Development of Financial Market'
        },
        {
            value: 'RA000918',
            labelcz: 'National Bank of Kazakhstan',
            labelen: 'National Bank of Kazakhstan'
        },
        {
            value: 'RA000919',
            labelcz: 'Astana Financial Services Authority, Astana International Financial Centre (AIFC)',
            labelen: 'Astana Financial Services Authority, Astana International Financial Centre (AIFC)'
        }
    ],
    KE: [
        {
            value: 'RA000417',
            labelcz: 'Registrar General Office of the Attorney General and Department of Justice',
            labelen: 'Registrar General Office of the Attorney General and Department of Justice'
        },
        {
            value: 'RA000920',
            labelcz: 'Central Bank of Kenya',
            labelen: 'Central Bank of Kenya'
        },
        {
            value: 'RA000921',
            labelcz: 'Capital Markets Authority',
            labelen: 'Capital Markets Authority'
        }
    ],
    KI: [
        {
            value: 'RA000418',
            labelcz: 'Business and Companies Regulatory Division (Ministry of Commerce, Industry and Cooperatives)',
            labelen: 'Business and Companies Regulatory Division (Ministry of Commerce, Industry and Cooperatives)'
        },
        {
            value: 'RA000922',
            labelcz: 'Ministry of Finance & Economic Development',
            labelen: 'Ministry of Finance & Economic Development'
        }
    ],
    XK: [
        {
            value: 'RA000519',
            labelcz: 'Registry of Business Organizations and Trade Names',
            labelen: 'Registry of Business Organizations and Trade Names'
        },
        {
            value: 'RA000925',
            labelcz: 'Central Bank of the Republic of Kosovo (CBK)',
            labelen: 'Central Bank of the Republic of Kosovo (CBK)'
        }
    ],
    KW: [
        {
            value: 'RA000420',
            labelcz: 'Kuwait Chamber of Commerce and Industry (KCCI)',
            labelen: 'Kuwait Chamber of Commerce and Industry (KCCI)'
        },
        {
            value: 'RA000926',
            labelcz: 'Central Bank of Kuwait',
            labelen: 'Central Bank of Kuwait'
        },
        {
            value: 'RA000927',
            labelcz: 'Capital Market Authority (CMA)',
            labelen: 'Capital Market Authority (CMA)'
        }
    ],
    KG: [
        {
            value: 'RA000421',
            labelcz: 'United State Register of Legal Entities and Branches (Ministry of Justice of Kyrgyz Republic)',
            labelen: 'United State Register of Legal Entities and Branches (Ministry of Justice of Kyrgyz Republic)'
        },
        {
            value: 'RA000928',
            labelcz: 'State Service for Regulation and Supervision of the Financial Market',
            labelen: 'State Service for Regulation and Supervision of the Financial Market'
        },
        {
            value: 'RA000929',
            labelcz: 'National Bank of the Kyrgyz Republic',
            labelen: 'National Bank of the Kyrgyz Republic'
        }
    ],
    LA: [
        {
            value: 'RA000422',
            labelcz: 'Enterprise Registration',
            labelen: 'Enterprise Registration'
        },
        {
            value: 'RA000930',
            labelcz: 'Bank of the Lao P.D.R',
            labelen: 'Bank of the Lao P.D.R'
        },
        {
            value: 'RA000931',
            labelcz: 'Lao Securities Commission',
            labelen: 'Lao Securities Commission'
        }
    ],
    LV: [
        {
            value: 'RA000423',
            labelcz: 'Commerce Register - Register of Enterprises of the Republic of Latvia',
            labelen: 'Commerce Register - Register of Enterprises of the Republic of Latvia'
        },
        {
            value: 'RA000424',
            labelcz: 'Databases of enterprises - Lursoft',
            labelen: 'Databases of enterprises - Lursoft'
        },
        {
            value: 'RA000932',
            labelcz: 'Financial and Capital Market Commission',
            labelen: 'Financial and Capital Market Commission'
        }
    ],
    LB: [
        {
            value: 'RA000425',
            labelcz: 'Commercial register - Ministry of Justice',
            labelen: 'Commercial register - Ministry of Justice'
        },
        {
            value: 'RA000729',
            labelcz: 'Directory - Office of the Minister of State for Administrative Reform (OMSAR)',
            labelen: 'Directory - Office of the Minister of State for Administrative Reform (OMSAR)'
        },
        {
            value: 'RA000933',
            labelcz: 'Capital Markets Authority',
            labelen: 'Capital Markets Authority'
        }
    ],
    LS: [
        {
            value: 'RA000426',
            labelcz: 'Company Register',
            labelen: 'Company Register'
        },
        {
            value: 'RA000934',
            labelcz: 'Central Bank of Lesotho',
            labelen: 'Central Bank of Lesotho'
        }
    ],
    LR: [
        {
            value: 'RA000427',
            labelcz: 'Liberia Business Registry',
            labelen: 'Liberia Business Registry'
        },
        {
            value: 'RA000935',
            labelcz: 'Central Bank of Liberia (CBL)',
            labelen: 'Central Bank of Liberia (CBL)'
        }
    ],
    LI: [
        {
            value: 'RA000428',
            labelcz: 'Commercial Register - Office of Justice',
            labelen: 'Commercial Register - Office of Justice'
        },
        {
            value: 'RA000429',
            labelcz: 'Financial Market Authority',
            labelen: 'Financial Market Authority'
        },
        {
            value: 'RA000548',
            labelcz: 'UID-Register',
            labelen: 'UID-Register'
        }
    ],
    LT: [
        {
            value: 'RA000430',
            labelcz: 'Register of Legal Entities',
            labelen: 'Register of Legal Entities'
        },
        {
            value: 'RA000431',
            labelcz: 'Central Bank of the Republic of Lithuania',
            labelen: 'Central Bank of the Republic of Lithuania'
        }
    ],
    LU: [
        {
            value: 'RA000432',
            labelcz: 'Trade and Company Register',
            labelen: 'Trade and Company Register'
        },
        {
            value: 'RA000433',
            labelcz: 'CSSF - Entités Surveillées',
            labelen: 'CSSF - Entités Surveillées'
        },
        {
            value: 'RA000434',
            labelcz: 'Legilux - Official Journal',
            labelen: 'Legilux - Official Journal'
        },
        {
            value: 'RA000435',
            labelcz: 'Fundsquare Market Infrastructure',
            labelen: 'Fundsquare Market Infrastructure'
        },
        {
            value: 'RA001048',
            labelcz: 'Luxembourg Bar Association',
            labelen: 'Luxembourg Bar Association'
        }
    ],
    MO: [
        {
            value: 'RA000436',
            labelcz: 'Directorate of Justice Affairs Services',
            labelen: 'Directorate of Justice Affairs Services'
        },
        {
            value: 'RA000938',
            labelcz: 'Monetary Authority of Macao',
            labelen: 'Monetary Authority of Macao'
        }
    ],
    MG: [
        {
            value: 'RA000679',
            labelcz: 'National Register of Commerce and Companies',
            labelen: 'National Register of Commerce and Companies'
        },
        {
            value: 'RA000939',
            labelcz: 'Central Bank of Madagascar',
            labelen: 'Central Bank of Madagascar'
        }
    ],
    MW: [
        {
            value: 'RA000438',
            labelcz: 'Registration of Businesses and Non Profit Making Entities',
            labelen: 'Registration of Businesses and Non Profit Making Entities'
        },
        {
            value: 'RA000940',
            labelcz: 'Reserve Bank of Malawi',
            labelen: 'Reserve Bank of Malawi'
        }
    ],
    MY: [
        {
            value: 'RA000439',
            labelcz: 'Corporate Registry',
            labelen: 'Corporate Registry'
        },
        {
            value: 'RA000941',
            labelcz: 'Labuan Financial Services Authority',
            labelen: 'Labuan Financial Services Authority'
        },
        {
            value: 'RA000942',
            labelcz: 'Securities Commission Malaysia',
            labelen: 'Securities Commission Malaysia'
        },
        {
            value: 'RA001109',
            labelcz: 'Societies Registration',
            labelen: 'Societies Registration'
        }
    ],
    MV: [
        {
            value: 'RA000441',
            labelcz: 'Ministry of Economic Development',
            labelen: 'Ministry of Economic Development'
        },
        {
            value: 'RA000943',
            labelcz: 'Capital Market Development Authority',
            labelen: 'Capital Market Development Authority'
        },
        {
            value: 'RA000944',
            labelcz: 'The Maldives Monetary Authority',
            labelen: 'The Maldives Monetary Authority'
        }
    ],
    ML: [
        {
            value: 'RA000442',
            labelcz: 'Investment Promotion Agency',
            labelen: 'Investment Promotion Agency'
        },
        {
            value: 'RA000814',
            labelcz: 'Central Bank of West African States (BCEAO)',
            labelen: 'Central Bank of West African States (BCEAO)'
        }
    ],
    MT: [
        {
            value: 'RA000443',
            labelcz: 'Malta Business Registry (MBR)',
            labelen: 'Malta Business Registry (MBR)'
        },
        {
            value: 'RA000945',
            labelcz: 'Malta Financial Services Authority',
            labelen: 'Malta Financial Services Authority'
        },
        {
            value: 'RA001061',
            labelcz: 'Voluntary Organisations Directory',
            labelen: 'Voluntary Organisations Directory'
        },
        {
            value: 'RA001103',
            labelcz: "Co-operatives' Directory",
            labelen: "Co-operatives' Directory"
        }
    ],
    MH: [
        {
            value: 'RA000444',
            labelcz: 'Marshall Islands Maritime and Corporate Administrators',
            labelen: 'Marshall Islands Maritime and Corporate Administrators'
        },
        {
            value: 'RA000946',
            labelcz: 'Ministry of Finance',
            labelen: 'Ministry of Finance'
        }
    ],
    MQ: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        }
    ],
    MR: [
        {
            value: 'RA000446',
            labelcz: 'Commercial Registry',
            labelen: 'Commercial Registry'
        },
        {
            value: 'RA000947',
            labelcz: 'Central Bank of Mauritania',
            labelen: 'Central Bank of Mauritania'
        }
    ],
    MU: [
        {
            value: 'RA000447',
            labelcz: 'Corporate and Business Registration',
            labelen: 'Corporate and Business Registration'
        },
        {
            value: 'RA000757',
            labelcz: 'Register of Licensees',
            labelen: 'Register of Licensees'
        }
    ],
    YT: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        }
    ],
    MX: [
        {
            value: 'RA000449',
            labelcz: 'Taxpayer Register',
            labelen: 'Taxpayer Register'
        },
        {
            value: 'RA000682',
            labelcz: 'Ministry of Finance and Public Credit',
            labelen: 'Ministry of Finance and Public Credit'
        },
        {
            value: 'RA000703',
            labelcz: 'Public Register of Commerce',
            labelen: 'Public Register of Commerce'
        },
        {
            value: 'RA000949',
            labelcz: 'Comisión Nacional Bancaria y de Valores (CNBV); Secretaría de Hacienda y Crédito Público',
            labelen: 'Comisión Nacional Bancaria y de Valores (CNBV); Secretaría de Hacienda y Crédito Público'
        }
    ],
    MD: [
        {
            value: 'RA000451',
            labelcz: 'State Register of Legal Entities',
            labelen: 'State Register of Legal Entities'
        },
        {
            value: 'RA000950',
            labelcz: 'National Commission for Financial Markets',
            labelen: 'National Commission for Financial Markets'
        },
        {
            value: 'RA000951',
            labelcz: 'National Bank of Moldova',
            labelen: 'National Bank of Moldova'
        }
    ],
    MC: [
        {
            value: 'RA000452',
            labelcz: 'Registry of Commerce and Industry',
            labelen: 'Registry of Commerce and Industry'
        },
        {
            value: 'RA000453',
            labelcz: 'Financial Activities Supervisory Commission',
            labelen: 'Financial Activities Supervisory Commission'
        },
        {
            value: 'RA001082',
            labelcz: 'Registre de groupements associatifs',
            labelen: 'Registre de groupements associatifs'
        }
    ],
    MN: [
        {
            value: 'RA000454',
            labelcz: 'Mongolian State Registration Office',
            labelen: 'Mongolian State Registration Office'
        },
        {
            value: 'RA000952',
            labelcz: 'Financial Regulatory Commission',
            labelen: 'Financial Regulatory Commission'
        }
    ],
    ME: [
        {
            value: 'RA000455',
            labelcz: 'Central Registry of Business Entities of the Tax Administration (CRBE)',
            labelen: 'Central Registry of Business Entities of the Tax Administration (CRBE)'
        },
        {
            value: 'RA000953',
            labelcz: 'Securities and Exchange Commission of Montenegro (SECMN)',
            labelen: 'Securities and Exchange Commission of Montenegro (SECMN)'
        },
        {
            value: 'RA000954',
            labelcz: 'Central Bank of Montenegro',
            labelen: 'Central Bank of Montenegro'
        }
    ],
    MS: [
        {
            value: 'RA000456',
            labelcz: 'Financial Services Commission Montserrat',
            labelen: 'Financial Services Commission Montserrat'
        }
    ],
    MA: [
        {
            value: 'RA000457',
            labelcz: 'Central Trade Register',
            labelen: 'Central Trade Register'
        },
        {
            value: 'RA000955',
            labelcz: 'Moroccan Capital Market Authority',
            labelen: 'Moroccan Capital Market Authority'
        },
        {
            value: 'RA001114',
            labelcz: 'Administrative and Judicial Services portal',
            labelen: 'Administrative and Judicial Services portal'
        }
    ],
    MZ: [
        {
            value: 'RA000458',
            labelcz: 'Commercial Registry',
            labelen: 'Commercial Registry'
        },
        {
            value: 'RA000956',
            labelcz: 'Bank of Mozambique',
            labelen: 'Bank of Mozambique'
        }
    ],
    MM: [
        {
            value: 'RA000459',
            labelcz: 'Directorate of Investment and Company Administration',
            labelen: 'Directorate of Investment and Company Administration'
        },
        {
            value: 'RA000957',
            labelcz: 'Securities and Exchange Commission of Myanmar',
            labelen: 'Securities and Exchange Commission of Myanmar'
        },
        {
            value: 'RA000958',
            labelcz: 'Central Bank of Myanmar',
            labelen: 'Central Bank of Myanmar'
        }
    ],
    NA: [
        {
            value: 'RA000460',
            labelcz: 'Business Register',
            labelen: 'Business Register'
        },
        {
            value: 'RA000959',
            labelcz: 'Bank of Namibia',
            labelen: 'Bank of Namibia'
        },
        {
            value: 'RA000960',
            labelcz: 'Namibia Financial Institutions Supervisory Authority (NAMFISA)',
            labelen: 'Namibia Financial Institutions Supervisory Authority (NAMFISA)'
        }
    ],
    NR: [
        {
            value: 'RA000461',
            labelcz: 'Office of the Registrar of Corporations',
            labelen: 'Office of the Registrar of Corporations'
        },
        {
            value: 'RA000961',
            labelcz: 'Department of Finance',
            labelen: 'Department of Finance'
        }
    ],
    NP: [
        {
            value: 'RA000462',
            labelcz: 'Company Register',
            labelen: 'Company Register'
        },
        {
            value: 'RA000962',
            labelcz: 'Securities Board of Nepal',
            labelen: 'Securities Board of Nepal'
        }
    ],
    NL: [
        {
            value: 'RA000463',
            labelcz: 'Business Register',
            labelen: 'Business Register'
        },
        {
            value: 'RA000464',
            labelcz: 'The Netherlands Authority for the Financial Markets',
            labelen: 'The Netherlands Authority for the Financial Markets'
        },
        {
            value: 'RA000664',
            labelcz: 'Public Benefit Organisation Register',
            labelen: 'Public Benefit Organisation Register'
        },
        {
            value: 'RA001047',
            labelcz: 'Public Register',
            labelen: 'Public Register'
        }
    ],
    NC: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        },
        {
            value: 'RA000963',
            labelcz: 'Institut de la statistique et des études économiques Nouvell-Calédonie (ISEE)',
            labelen: 'Institut de la statistique et des études économiques Nouvell-Calédonie (ISEE)'
        }
    ],
    NZ: [
        {
            value: 'RA000466',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA000749',
            labelcz: 'New Zealand Business Number Register',
            labelen: 'New Zealand Business Number Register'
        },
        {
            value: 'RA000964',
            labelcz: 'Financial Markets Authority New Zealand',
            labelen: 'Financial Markets Authority New Zealand'
        },
        {
            value: 'RA001079',
            labelcz: 'Disclose Register',
            labelen: 'Disclose Register'
        },
        {
            value: 'RA001098',
            labelcz: 'Incorporated Societies Register',
            labelen: 'Incorporated Societies Register'
        }
    ],
    NI: [
        {
            value: 'RA000467',
            labelcz: 'Registro Público de la Propiedad Inmueble y Mercantil',
            labelen: 'Registro Público de la Propiedad Inmueble y Mercantil'
        },
        {
            value: 'RA000965',
            labelcz: 'Superintendecia de Bancos y otras Instituciones Financieras',
            labelen: 'Superintendecia de Bancos y otras Instituciones Financieras'
        }
    ],
    NE: [
        {
            value: 'RA000468',
            labelcz: 'Registre du Commerce et du Crédit Mobilier (RCCM)',
            labelen: 'Registre du Commerce et du Crédit Mobilier (RCCM)'
        },
        {
            value: 'RA000814',
            labelcz: 'Central Bank of West African States (BCEAO)',
            labelen: 'Central Bank of West African States (BCEAO)'
        }
    ],
    NG: [
        {
            value: 'RA000469',
            labelcz: 'Company Registry',
            labelen: 'Company Registry'
        },
        {
            value: 'RA000966',
            labelcz: 'Securities and Exchange Commission',
            labelen: 'Securities and Exchange Commission'
        },
        {
            value: 'RA000967',
            labelcz: 'Central Bank of Nigeria',
            labelen: 'Central Bank of Nigeria'
        }
    ],
    NU: [
        {
            value: 'RA000470',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        }
    ],
    MK: [
        {
            value: 'RA000437',
            labelcz: 'Central Register of the Republic of Macedonia',
            labelen: 'Central Register of the Republic of Macedonia'
        },
        {
            value: 'RA000968',
            labelcz: 'Securities and Exchange Commission',
            labelen: 'Securities and Exchange Commission'
        },
        {
            value: 'RA000969',
            labelcz: 'National Bank of the Republic of North Macedonia',
            labelen: 'National Bank of the Republic of North Macedonia'
        }
    ],
    MP: [
        {
            value: 'RA000471',
            labelcz: 'Registrar of Corporations (Department of Commerce)',
            labelen: 'Registrar of Corporations (Department of Commerce)'
        },
        {
            value: 'RA000970',
            labelcz: 'Department of Finance',
            labelen: 'Department of Finance'
        }
    ],
    NO: [
        {
            value: 'RA000472',
            labelcz: 'The Register of Business Enterprises',
            labelen: 'The Register of Business Enterprises'
        },
        {
            value: 'RA000473',
            labelcz: 'The Central Coordinating Register for Legal Entities',
            labelen: 'The Central Coordinating Register for Legal Entities'
        },
        {
            value: 'RA000971',
            labelcz: 'Financial Supervisory Authority',
            labelen: 'Financial Supervisory Authority'
        }
    ],
    OM: [
        {
            value: 'RA000474',
            labelcz: 'National Business Register',
            labelen: 'National Business Register'
        },
        {
            value: 'RA000972',
            labelcz: 'Capital Market Authority',
            labelen: 'Capital Market Authority'
        }
    ],
    PK: [
        {
            value: 'RA000475',
            labelcz: 'Corporate Registry',
            labelen: 'Corporate Registry'
        },
        {
            value: 'RA001111',
            labelcz: 'Online Verification Services',
            labelen: 'Online Verification Services'
        }
    ],
    PW: [
        {
            value: 'RA000476',
            labelcz: 'Corporate Registrar at the Office of the Attorney General',
            labelen: 'Corporate Registrar at the Office of the Attorney General'
        },
        {
            value: 'RA000973',
            labelcz: 'Financial Institutions Commission',
            labelen: 'Financial Institutions Commission'
        }
    ],
    PS: [
        {
            value: 'RA000477',
            labelcz: 'Companies Registry',
            labelen: 'Companies Registry'
        },
        {
            value: 'RA000974',
            labelcz: 'Palestine Capital Market Authority',
            labelen: 'Palestine Capital Market Authority'
        },
        {
            value: 'RA000975',
            labelcz: 'Palestine Monetary Authority (PMA)',
            labelen: 'Palestine Monetary Authority (PMA)'
        }
    ],
    PA: [
        {
            value: 'RA000478',
            labelcz: 'Public Registry of Panama',
            labelen: 'Public Registry of Panama'
        },
        {
            value: 'RA000976',
            labelcz: 'Superintendencia del Mercado de Valores',
            labelen: 'Superintendencia del Mercado de Valores'
        },
        {
            value: 'RA001093',
            labelcz: 'Registro Único de Contribuyentes (RUC)',
            labelen: 'Registro Único de Contribuyentes (RUC)'
        }
    ],
    PG: [
        {
            value: 'RA000479',
            labelcz: 'Registrar of Companies (Investment Promotion Authority )',
            labelen: 'Registrar of Companies (Investment Promotion Authority )'
        },
        {
            value: 'RA000977',
            labelcz: 'Bank of Papua New Guinea',
            labelen: 'Bank of Papua New Guinea'
        }
    ],
    PY: [
        {
            value: 'RA000480',
            labelcz: 'Ministry of Industry and Commerce',
            labelen: 'Ministry of Industry and Commerce'
        },
        {
            value: 'RA000481',
            labelcz: 'Unified Business Opening System',
            labelen: 'Unified Business Opening System'
        },
        {
            value: 'RA000978',
            labelcz: 'National Securities Commission',
            labelen: 'National Securities Commission'
        },
        {
            value: 'RA001072',
            labelcz: 'Registro Único de Contribuyentes (RUC)',
            labelen: 'Registro Único de Contribuyentes (RUC)'
        }
    ],
    PE: [
        {
            value: 'RA000482',
            labelcz: 'Public Register of Commerce',
            labelen: 'Public Register of Commerce'
        },
        {
            value: 'RA000689',
            labelcz: 'Registro Único de Contribuyentes (RUC)',
            labelen: 'Registro Único de Contribuyentes (RUC)'
        },
        {
            value: 'RA000979',
            labelcz: 'Superintendencia del Mercado de Valores',
            labelen: 'Superintendencia del Mercado de Valores'
        },
        {
            value: 'RA000980',
            labelcz: 'Superintendencia de Banca y Seguros (SBS)',
            labelen: 'Superintendencia de Banca y Seguros (SBS)'
        }
    ],
    PH: [
        {
            value: 'RA000483',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA000760',
            labelcz: 'Business Name Registration',
            labelen: 'Business Name Registration'
        },
        {
            value: 'RA000761',
            labelcz: 'Cooperative Development Authority',
            labelen: 'Cooperative Development Authority'
        }
    ],
    PL: [
        {
            value: 'RA000484',
            labelcz: 'National Court Register',
            labelen: 'National Court Register'
        },
        {
            value: 'RA000485',
            labelcz: 'Investment Fund Management Companies,  Investment Funds and Pension Funds',
            labelen: 'Investment Fund Management Companies,  Investment Funds and Pension Funds'
        },
        {
            value: 'RA000486',
            labelcz: 'Central Registration and Information on Business',
            labelen: 'Central Registration and Information on Business'
        },
        {
            value: 'RA000654',
            labelcz: 'National Official Business Register (REGON)',
            labelen: 'National Official Business Register (REGON)'
        }
    ],
    PT: [
        {
            value: 'RA000487',
            labelcz: 'Commercial Register',
            labelen: 'Commercial Register'
        },
        {
            value: 'RA000488',
            labelcz: 'Securities Market Commission',
            labelen: 'Securities Market Commission'
        },
        {
            value: 'RA000489',
            labelcz: 'Insurance and pension funds supervisison autority',
            labelen: 'Insurance and pension funds supervisison autority'
        },
        {
            value: 'RA000784',
            labelcz: 'Directorate-General for Social Security',
            labelen: 'Directorate-General for Social Security'
        },
        {
            value: 'RA000981',
            labelcz: 'Central Bank of Portugal',
            labelen: 'Central Bank of Portugal'
        }
    ],
    PR: [
        {
            value: 'RA000493',
            labelcz: 'Puerto Rico Department of State',
            labelen: 'Puerto Rico Department of State'
        },
        {
            value: 'RA000745',
            labelcz: 'National Credit Union Administration',
            labelen: 'National Credit Union Administration'
        },
        {
            value: 'RA000665',
            labelcz: 'Securities and Exchange Commission',
            labelen: 'Securities and Exchange Commission'
        },
        {
            value: 'RA000982',
            labelcz: 'Office of the Commissioner of Financial Institutions',
            labelen: 'Office of the Commissioner of Financial Institutions'
        }
    ],
    QA: [
        {
            value: 'RA000494',
            labelcz: 'Registry of Corporations and Entities',
            labelen: 'Registry of Corporations and Entities'
        },
        {
            value: 'RA000495',
            labelcz: 'Registry of federally insured credit unions',
            labelen: 'Registry of federally insured credit unions'
        },
        {
            value: 'RA000983',
            labelcz: 'Qatar Financial Markets Authority',
            labelen: 'Qatar Financial Markets Authority'
        },
        {
            value: 'RA000984',
            labelcz: 'Qatar Financial Centre Regulatory Authority (QFCRA)',
            labelen: 'Qatar Financial Centre Regulatory Authority (QFCRA)'
        }
    ],
    KR: [
        {
            value: 'RA000419',
            labelcz: 'Corporation registration',
            labelen: 'Corporation registration'
        },
        {
            value: 'RA000657',
            labelcz: 'Business registration',
            labelen: 'Business registration'
        },
        {
            value: 'RA000658',
            labelcz: 'Funds Registration',
            labelen: 'Funds Registration'
        },
        {
            value: 'RA000923',
            labelcz: 'Financial Services Commission',
            labelen: 'Financial Services Commission'
        },
        {
            value: 'RA001065',
            labelcz: 'Foreign Investment Company Information',
            labelen: 'Foreign Investment Company Information'
        },
        {
            value: 'RA001073',
            labelcz: "Repository of Korea's Corporate Filings; Data Analysis, Retrieval and Transfer System (DART)",
            labelen: "Repository of Korea's Corporate Filings; Data Analysis, Retrieval and Transfer System (DART)"
        }
    ],
    RO: [
        {
            value: 'RA000497',
            labelcz: 'Trade Register',
            labelen: 'Trade Register'
        },
        {
            value: 'RA000498',
            labelcz: 'Financial Instruments and Investments Registry',
            labelen: 'Financial Instruments and Investments Registry'
        },
        {
            value: 'RA000718',
            labelcz: 'NGO register',
            labelen: 'NGO register'
        },
        {
            value: 'RA000719',
            labelcz: 'Tax Payer Register',
            labelen: 'Tax Payer Register'
        },
        {
            value: 'RA000720',
            labelcz: 'National Register of Public Institutions',
            labelen: 'National Register of Public Institutions'
        },
        {
            value: 'RA000721',
            labelcz: 'National Bank of Romania Public Registers',
            labelen: 'National Bank of Romania Public Registers'
        }
    ],
    RU: [
        {
            value: 'RA000499',
            labelcz: 'Unified State Register of Legal Entities',
            labelen: 'Unified State Register of Legal Entities'
        },
        {
            value: 'RA000985',
            labelcz: 'Bank of Russia',
            labelen: 'Bank of Russia'
        }
    ],
    RW: [
        {
            value: 'RA000500',
            labelcz: 'Business Register',
            labelen: 'Business Register'
        },
        {
            value: 'RA000986',
            labelcz: 'National Bank of Rwanda',
            labelen: 'National Bank of Rwanda'
        },
        {
            value: 'RA000987',
            labelcz: 'Capital Market Authority',
            labelen: 'Capital Market Authority'
        }
    ],
    RE: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        }
    ],
    BL: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        }
    ],
    KN: [
        {
            value: 'RA000502',
            labelcz: 'Registrar of Companies (Financial Services Regulatory Comission)',
            labelen: 'Registrar of Companies (Financial Services Regulatory Comission)'
        },
        {
            value: 'RA000990',
            labelcz: 'Financial Services Regulatory Comission Nevis branch',
            labelen: 'Financial Services Regulatory Comission Nevis branch'
        },
        {
            value: 'RA000989',
            labelcz: 'Financial Services Regulatory Comission St. Kitts branch',
            labelen: 'Financial Services Regulatory Comission St. Kitts branch'
        },
        {
            value: 'RA001086',
            labelcz: 'Local Companies Registry',
            labelen: 'Local Companies Registry'
        }
    ],
    LC: [
        {
            value: 'RA000503',
            labelcz: 'Registry of Companies and Intellectual Property',
            labelen: 'Registry of Companies and Intellectual Property'
        },
        {
            value: 'RA000504',
            labelcz: 'Registry of International Business Companies and International Trusts',
            labelen: 'Registry of International Business Companies and International Trusts'
        },
        {
            value: 'RA000991',
            labelcz: 'Financial Services Regulatory Authority (FSRA)',
            labelen: 'Financial Services Regulatory Authority (FSRA)'
        }
    ],
    MF: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        }
    ],
    PM: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        }
    ],
    VC: [
        {
            value: 'RA000508',
            labelcz: 'St. Vincent & the Grenadines Commerce & Intellectual Property Office',
            labelen: 'St. Vincent & the Grenadines Commerce & Intellectual Property Office'
        },
        {
            value: 'RA000992',
            labelcz: 'Financial Services Authority',
            labelen: 'Financial Services Authority'
        }
    ],
    WS: [
        {
            value: 'RA000509',
            labelcz: 'Samoa International Finance Authority',
            labelen: 'Samoa International Finance Authority'
        },
        {
            value: 'RA000510',
            labelcz: 'Samoa Company Registry',
            labelen: 'Samoa Company Registry'
        }
    ],
    SM: [
        {
            value: 'RA000511',
            labelcz: 'Registry of Companies',
            labelen: 'Registry of Companies'
        },
        {
            value: 'RA000993',
            labelcz: 'Central Bank of the Republic of San Marino (CBSM)',
            labelen: 'Central Bank of the Republic of San Marino (CBSM)'
        }
    ],
    ST: [
        {
            value: 'RA000512',
            labelcz: 'RA000512',
            labelen: 'RA000512'
        },
        {
            value: 'RA000994',
            labelcz: 'Central Bank of São Tomé and Príncipe',
            labelen: 'Central Bank of São Tomé and Príncipe'
        }
    ],
    SA: [
        {
            value: 'RA000513',
            labelcz: 'Kingdom of Saudi Arabia Commercial Register',
            labelen: 'Kingdom of Saudi Arabia Commercial Register'
        },
        {
            value: 'RA000702',
            labelcz: 'Saudi Capital Market Authority',
            labelen: 'Saudi Capital Market Authority'
        }
    ],
    SN: [
        {
            value: 'RA000514',
            labelcz: 'Observation Post of Industrial Activities in Senegal',
            labelen: 'Observation Post of Industrial Activities in Senegal'
        },
        {
            value: 'RA000515',
            labelcz: 'Registre du Commerce et du Crédit Mobilier (RCCM)',
            labelen: 'Registre du Commerce et du Crédit Mobilier (RCCM)'
        },
        {
            value: 'RA000516',
            labelcz: 'Trade Point Senegal (Ministry of Commerce)',
            labelen: 'Trade Point Senegal (Ministry of Commerce)'
        },
        {
            value: 'RA000779',
            labelcz: 'Business Creation Support Bureau (BCE)',
            labelen: 'Business Creation Support Bureau (BCE)'
        },
        {
            value: 'RA000814',
            labelcz: 'Central Bank of West African States (BCEAO)',
            labelen: 'Central Bank of West African States (BCEAO)'
        }
    ],
    RS: [
        {
            value: 'RA000517',
            labelcz: 'Business Entities Register - Companies',
            labelen: 'Business Entities Register - Companies'
        },
        {
            value: 'RA000518',
            labelcz: 'Central Securities Depository and Clearing House',
            labelen: 'Central Securities Depository and Clearing House'
        },
        {
            value: 'RA000684',
            labelcz: 'Register of Investment Funds',
            labelen: 'Register of Investment Funds'
        }
    ],
    SC: [
        {
            value: 'RA000520',
            labelcz: 'Seychelles Financial Services Authority',
            labelen: 'Seychelles Financial Services Authority'
        },
        {
            value: 'RA000521',
            labelcz: 'Seychelles Business Registry',
            labelen: 'Seychelles Business Registry'
        }
    ],
    SL: [
        {
            value: 'RA000522',
            labelcz: 'Business Registry',
            labelen: 'Business Registry'
        },
        {
            value: 'RA000995',
            labelcz: 'Bank of Sierra Leone',
            labelen: 'Bank of Sierra Leone'
        }
    ],
    SG: [
        {
            value: 'RA000523',
            labelcz: 'Business Registry',
            labelen: 'Business Registry'
        },
        {
            value: 'RA000524',
            labelcz: 'Monetary Authority of Singapore',
            labelen: 'Monetary Authority of Singapore'
        },
        {
            value: 'RA000669',
            labelcz: 'Registry of Societies',
            labelen: 'Registry of Societies'
        },
        {
            value: 'RA000781',
            labelcz: 'Charity Portal',
            labelen: 'Charity Portal'
        },
        {
            value: 'RA000996',
            labelcz: 'Monetary Authority of Singapore',
            labelen: 'Monetary Authority of Singapore'
        }
    ],
    SX: [
        {
            value: 'RA000525',
            labelcz: 'Trade Register',
            labelen: 'Trade Register'
        },
        {
            value: 'RA000855',
            labelcz: 'Central Bank of Curaçao and Sint Maarten',
            labelen: 'Central Bank of Curaçao and Sint Maarten'
        }
    ],
    SK: [
        {
            value: 'RA000526',
            labelcz: 'Obchodný register',
            labelen: 'Business Registe'
        },
        {
            value: 'RA000527',
            labelcz: 'Evidencia občianskych združení',
            labelen: 'Evidence of Civil Associations'
        },
        {
            value: 'RA000528',
            labelcz: 'Register neziskových organizácií',
            labelen: 'Register of Non-profit Organisations'
        },
        {
            value: 'RA000670',
            labelcz: 'Živnostenský register',
            labelen: 'Trade Register'
        },
        {
            value: 'RA000671',
            labelcz: 'Štatistický úrad',
            labelen: 'The Statistical Office'
        },
        {
            value: 'RA000672',
            labelcz: 'Register nadácií',
            labelen: 'Register of Foundations'
        },
        {
            value: 'RA000673',
            labelcz: 'Register záujmových združení právnických osôb',
            labelen: 'Register of the Interest Associations of Legal Persons'
        },
        {
            value: 'RA000674',
            labelcz: 'Register združení obcí',
            labelen: 'Register of Associations of Municipalities'
        },
        {
            value: 'RA000675',
            labelcz: 'Register neinvestičných fondov',
            labelen: 'Register of Non-investment Funds'
        },
        {
            value: 'RA000676',
            labelcz: 'Organizácie s medzinárodným prvkom',
            labelen: 'Organisations with the International Element'
        },
        {
            value: 'RA000677',
            labelcz: 'Register politických strán a politických hnutí',
            labelen: 'Register of Political Parties and Political Movements'
        },
        {
            value: 'RA000706',
            labelcz: 'Zoznam podielových fondov',
            labelen: 'List of Investment Funds'
        }
    ],
    SI: [
        {
            value: 'RA000529',
            labelcz: 'Slovenian Business Register',
            labelen: 'Slovenian Business Register'
        },
        {
            value: 'RA000997',
            labelcz: 'Securities Market Agency',
            labelen: 'Securities Market Agency'
        }
    ],
    SB: [
        {
            value: 'RA000530',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA000998',
            labelcz: 'Central Bank of Solomon Islands',
            labelen: 'Central Bank of Solomon Islands'
        }
    ],
    ZA: [
        {
            value: 'RA000531',
            labelcz: 'Corporate Registers',
            labelen: 'Corporate Registers'
        },
        {
            value: 'RA000782',
            labelcz: 'Financial Sector Conduct Authority',
            labelen: 'Financial Sector Conduct Authority'
        },
        {
            value: 'RA000999',
            labelcz: 'Master of the High Court; Department of Justice and Constitutional Development',
            labelen: 'Master of the High Court; Department of Justice and Constitutional Development'
        },
        {
            value: 'RA001000',
            labelcz: 'Prudential Authority, South African Reserve Bank',
            labelen: 'Prudential Authority, South African Reserve Bank'
        }
    ],
    SS: [
        {
            value: 'RA000532',
            labelcz: 'Business Registry',
            labelen: 'Business Registry'
        },
        {
            value: 'RA001001',
            labelcz: 'Bank of South Sudan',
            labelen: 'Bank of South Sudan'
        }
    ],
    ES: [
        {
            value: 'RA000728',
            labelcz: 'Inventory of Regional Institutions',
            labelen: 'Inventory of Regional Institutions'
        },
        {
            value: 'RA000533',
            labelcz: 'Commercial Registry',
            labelen: 'Commercial Registry'
        },
        {
            value: 'RA000534',
            labelcz: 'National Securities Market Commission',
            labelen: 'National Securities Market Commission'
        },
        {
            value: 'RA000535',
            labelcz: 'Tax Agency',
            labelen: 'Tax Agency'
        },
        {
            value: 'RA000536',
            labelcz: 'Register of Foundations',
            labelen: 'Register of Foundations'
        },
        {
            value: 'RA000537',
            labelcz: 'National Associations Register',
            labelen: 'National Associations Register'
        },
        {
            value: 'RA000538',
            labelcz: 'Register of Cooperative Societies',
            labelen: 'Register of Cooperative Societies'
        },
        {
            value: 'RA000539',
            labelcz: 'Directorate General for Insurances and Pension Funds',
            labelen: 'Directorate General for Insurances and Pension Funds'
        },
        {
            value: 'RA000716',
            labelcz: 'Register of Religious Entities',
            labelen: 'Register of Religious Entities'
        },
        {
            value: 'RA000767',
            labelcz: 'Register of Associations of Professionals',
            labelen: 'Register of Associations of Professionals'
        },
        {
            value: 'RA000780',
            labelcz: 'Central Mercantile Registry',
            labelen: 'Central Mercantile Registry'
        },
        {
            value: 'RA001003',
            labelcz: 'Community of Madrid',
            labelen: 'Community of Madrid'
        },
        {
            value: 'RA001002',
            labelcz: 'General Comptroller of the State Administration (IGAE; Ministry of Finance and Civil Service)',
            labelen: 'General Comptroller of the State Administration (IGAE; Ministry of Finance and Civil Service)'
        },
        {
            value: 'RA001060',
            labelcz: 'Registro de Asociaciones, Fundaciones y Colegios profesionales',
            labelen: 'Registro de Asociaciones, Fundaciones y Colegios profesionales'
        },
        {
            value: 'RA001064',
            labelcz: 'Sede Electrónica',
            labelen: 'Sede Electrónica'
        },
        {
            value: 'RA001067',
            labelcz: 'Registry of Foundations',
            labelen: 'Registry of Foundations'
        },
        {
            value: 'RA001068',
            labelcz: 'Registry of Associations',
            labelen: 'Registry of Associations'
        },
        {
            value: 'RA001071',
            labelcz: 'Registro de Universidades, Centros y Títulos (RUCT)',
            labelen: 'Registro de Universidades, Centros y Títulos (RUCT)'
        },
        {
            value: 'RA001078',
            labelcz: 'Registro de colegios profesionales y consejos de colegios',
            labelen: 'Registro de colegios profesionales y consejos de colegios'
        },
        {
            value: 'RA001080',
            labelcz: 'Registry of Cooperatives',
            labelen: 'Registry of Cooperatives'
        },
        {
            value: 'RA001084',
            labelcz: 'Verificación de documentos',
            labelen: 'Verificación de documentos'
        },
        {
            value: 'RA001101',
            labelcz: 'Departamento de Hacienda y Finanzas',
            labelen: 'Departamento de Hacienda y Finanzas'
        },
        {
            value: 'RA001105',
            labelcz: 'Hacienda Foral de Álava',
            labelen: 'Hacienda Foral de Álava'
        },
        {
            value: 'RA001113',
            labelcz: 'Registro de Asociaciones de Castilla y León',
            labelen: 'Registro de Asociaciones de Castilla y León'
        }
    ],
    LK: [
        {
            value: 'RA000540',
            labelcz: 'Department of Registrar of Companies',
            labelen: 'Department of Registrar of Companies'
        },
        {
            value: 'RA001004',
            labelcz: 'Securities and Exchange Commission of Sri Lanka',
            labelen: 'Securities and Exchange Commission of Sri Lanka'
        },
        {
            value: 'RA001005',
            labelcz: 'Central Bank of Sri Lanka',
            labelen: 'Central Bank of Sri Lanka'
        }
    ],
    SD: [
        {
            value: 'RA000541',
            labelcz: 'Ministry of Justice Commercial Registrations Department',
            labelen: 'Ministry of Justice Commercial Registrations Department'
        },
        {
            value: 'RA001006',
            labelcz: 'Central Bank of Sudan',
            labelen: 'Central Bank of Sudan'
        }
    ],
    SR: [
        {
            value: 'RA000542',
            labelcz: 'Trade Register',
            labelen: 'Trade Register'
        },
        {
            value: 'RA001007',
            labelcz: 'Central Bank of Suriname',
            labelen: 'Central Bank of Suriname'
        }
    ],
    SZ: [
        {
            value: 'RA000543',
            labelcz: 'Registrar of Companies',
            labelen: 'Registrar of Companies'
        },
        {
            value: 'RA000872',
            labelcz: 'Central Bank of Eswatini',
            labelen: 'Central Bank of Eswatini'
        },
        {
            value: 'RA000873',
            labelcz: 'Financial Services Regulatory Authority (FSRA)',
            labelen: 'Financial Services Regulatory Authority (FSRA)'
        }
    ],
    SE: [
        {
            value: 'RA000544',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA000545',
            labelcz: 'Statistics Sweden',
            labelen: 'Statistics Sweden'
        },
        {
            value: 'RA000546',
            labelcz: 'Swedish Tax Authority',
            labelen: 'Swedish Tax Authority'
        },
        {
            value: 'RA000547',
            labelcz: 'Financial Supervisory Authority',
            labelen: 'Financial Supervisory Authority'
        },
        {
            value: 'RA000735',
            labelcz: "The county administrative boards' common foundation database",
            labelen: "The county administrative boards' common foundation database"
        }
    ],
    CH: [
        {
            value: 'RA000548',
            labelcz: 'UID-Register',
            labelen: 'UID-Register'
        },
        {
            value: 'RA000549',
            labelcz: 'Commercial Register',
            labelen: 'Commercial Register'
        },
        {
            value: 'RA000550',
            labelcz: 'Financial Market Supervisory Authority',
            labelen: 'Financial Market Supervisory Authority'
        },
        {
            value: 'RA000678',
            labelcz: 'Committee for the High Supervision of Pension Funds CHS PP',
            labelen: 'Committee for the High Supervision of Pension Funds CHS PP'
        }
    ],
    TW: [
        {
            value: 'RA000551',
            labelcz: 'Ministry of Economic Affairs',
            labelen: 'Ministry of Economic Affairs'
        },
        {
            value: 'RA001009',
            labelcz: 'Financial Supervisory Commission (FSC)',
            labelen: 'Financial Supervisory Commission (FSC)'
        }
    ],
    TJ: [
        {
            value: 'RA000552',
            labelcz:
                'Tajikistan State Register of Legal Entities and Individual Entrepreneurs (Tax Committee under the Government of Republic of Tajikistan)',
            labelen:
                'Tajikistan State Register of Legal Entities and Individual Entrepreneurs (Tax Committee under the Government of Republic of Tajikistan)'
        },
        {
            value: 'RA001010',
            labelcz: 'National Bank of Tajikistan',
            labelen: 'National Bank of Tajikistan'
        }
    ],
    TZ: [
        {
            value: 'RA000553',
            labelcz: 'Business Register',
            labelen: 'Business Register'
        },
        {
            value: 'RA001011',
            labelcz: 'Capital Markets and Securities Authority',
            labelen: 'Capital Markets and Securities Authority'
        },
        {
            value: 'RA001012',
            labelcz: 'Bank of Tanzania',
            labelen: 'Bank of Tanzania'
        }
    ],
    TH: [
        {
            value: 'RA000554',
            labelcz: 'Business Register',
            labelen: 'Business Register'
        },
        {
            value: 'RA001013',
            labelcz: 'Thailand Financial Instruments Information Center',
            labelen: 'Thailand Financial Instruments Information Center'
        },
        {
            value: 'RA001014',
            labelcz: 'Securities and Exchange Commission',
            labelen: 'Securities and Exchange Commission'
        }
    ],
    TL: [
        {
            value: 'RA000555',
            labelcz: 'RA000555',
            labelen: 'RA000555'
        },
        {
            value: 'RA001015',
            labelcz: 'Central Bank of Timor-Leste',
            labelen: 'Central Bank of Timor-Leste'
        }
    ],
    TG: [
        {
            value: 'RA000556',
            labelcz: 'Registre du Commerce et du Crédit Mobilier (RCCM)',
            labelen: 'Registre du Commerce et du Crédit Mobilier (RCCM)'
        },
        {
            value: 'RA000814',
            labelcz: 'Central Bank of West African States (BCEAO)',
            labelen: 'Central Bank of West African States (BCEAO)'
        },
        {
            value: 'RA001016',
            labelcz: 'Ministry of the Economy and Finance',
            labelen: 'Ministry of the Economy and Finance'
        }
    ],
    TO: [
        {
            value: 'RA000557',
            labelcz: 'Business Registries Office (Ministry of Commerce, Tourism and Labour)',
            labelen: 'Business Registries Office (Ministry of Commerce, Tourism and Labour)'
        },
        {
            value: 'RA001017',
            labelcz: 'National Reserve Bank of Tonga',
            labelen: 'National Reserve Bank of Tonga'
        }
    ],
    TT: [
        {
            value: 'RA000558',
            labelcz: "Registrar General's Department (Ministry of Legal Affairs)",
            labelen: "Registrar General's Department (Ministry of Legal Affairs)"
        },
        {
            value: 'RA001018',
            labelcz: 'Trinidad and Tobago Securities and Exchange Commission (TTSEC)',
            labelen: 'Trinidad and Tobago Securities and Exchange Commission (TTSEC)'
        },
        {
            value: 'RA001019',
            labelcz: 'Central Bank of Trinidad and Tobago',
            labelen: 'Central Bank of Trinidad and Tobago'
        }
    ],
    TN: [
        {
            value: 'RA000758',
            labelcz: 'National Register of Enterprises (RNE)',
            labelen: 'National Register of Enterprises (RNE)'
        },
        {
            value: 'RA001020',
            labelcz: 'Financial Market Council',
            labelen: 'Financial Market Council'
        },
        {
            value: 'RA001021',
            labelcz: 'Central Bank of Tunisia',
            labelen: 'Central Bank of Tunisia'
        }
    ],
    TR: [
        {
            value: 'RA000560',
            labelcz: 'Central Registry Number System (MERSIS)',
            labelen: 'Central Registry Number System (MERSIS)'
        },
        {
            value: 'RA000561',
            labelcz: 'Turkish Trade Registry Gazette (The Union of Chambers and Commodity Exchanges of Turkey)',
            labelen: 'Turkish Trade Registry Gazette (The Union of Chambers and Commodity Exchanges of Turkey)'
        },
        {
            value: 'RA000756',
            labelcz: 'Public Disclosure Platform',
            labelen: 'Public Disclosure Platform'
        },
        {
            value: 'RA001022',
            labelcz: 'Capital Markets Board of Turkey',
            labelen: 'Capital Markets Board of Turkey'
        }
    ],
    TM: [
        {
            value: 'RA000562',
            labelcz: 'Statistical Register of Economic Entities (State Committee of Statistics of Turkmenistan)',
            labelen: 'Statistical Register of Economic Entities (State Committee of Statistics of Turkmenistan)'
        },
        {
            value: 'RA001023',
            labelcz: 'Central Bank of Turkmenistan',
            labelen: 'Central Bank of Turkmenistan'
        }
    ],
    TC: [
        {
            value: 'RA000563',
            labelcz: 'Companies Registry',
            labelen: 'Companies Registry'
        }
    ],
    TV: [
        {
            value: 'RA000564',
            labelcz: 'Companies and Business Registration Register',
            labelen: 'Companies and Business Registration Register'
        }
    ],
    VI: [
        {
            value: 'RA000565',
            labelcz: 'Department of Licensing and Consumer Affairs',
            labelen: 'Department of Licensing and Consumer Affairs'
        },
        {
            value: 'RA000745',
            labelcz: 'Registry of federally insured credit unions',
            labelen: 'Registry of federally insured credit unions'
        },
        {
            value: 'RA000665',
            labelcz: 'Securities and Exchange Commission',
            labelen: 'Securities and Exchange Commission'
        },
        {
            value: 'RA001024',
            labelcz: 'Division of Banking, Insurance and Financial Regulation',
            labelen: 'Division of Banking, Insurance and Financial Regulation'
        },
        {
            value: 'RA001050',
            labelcz: 'Business Entity Registry',
            labelen: 'Business Entity Registry'
        }
    ],
    UG: [
        {
            value: 'RA000566',
            labelcz: 'Directorate of Business Registration of Uganda Registration Services Bureau',
            labelen: 'Directorate of Business Registration of Uganda Registration Services Bureau'
        },
        {
            value: 'RA000662',
            labelcz: 'Supervised Financial Institutions',
            labelen: 'Supervised Financial Institutions'
        },
        {
            value: 'RA001025',
            labelcz: 'Capital Markets Authority',
            labelen: 'Capital Markets Authority'
        }
    ],
    UA: [
        {
            value: 'RA000567',
            labelcz:
                'United State Register of Legal Entities and Individual Entrepreneurs of Ukraine (State register service of Ukraine)',
            labelen:
                'United State Register of Legal Entities and Individual Entrepreneurs of Ukraine (State register service of Ukraine)'
        },
        {
            value: 'RA001026',
            labelcz: 'National Securities and Stock Market Commission (NSSMC)',
            labelen: 'National Securities and Stock Market Commission (NSSMC)'
        },
        {
            value: 'RA001027',
            labelcz: 'National Bank of Ukraine',
            labelen: 'National Bank of Ukraine'
        }
    ],
    AE: [
        {
            value: 'RA000568',
            labelcz: 'Abu Dhabi Commercial Directory',
            labelen: 'Abu Dhabi Commercial Directory'
        },
        {
            value: 'RA000569',
            labelcz: 'Register of Companies',
            labelen: 'Register of Companies'
        },
        {
            value: 'RA000570',
            labelcz: 'Ajman Free Zone Authority',
            labelen: 'Ajman Free Zone Authority'
        },
        {
            value: 'RA000571',
            labelcz: 'Chamber of Commerce and Industry: Industrial and Business Directory',
            labelen: 'Chamber of Commerce and Industry: Industrial and Business Directory'
        },
        {
            value: 'RA000572',
            labelcz: 'Department of Economic Development - Ajman',
            labelen: 'Department of Economic Development - Ajman'
        },
        {
            value: 'RA000573',
            labelcz: 'Department of Economic Development - Dubai',
            labelen: 'Department of Economic Development - Dubai'
        },
        {
            value: 'RA000574',
            labelcz: 'Dubai Airport Free Zone',
            labelen: 'Dubai Airport Free Zone'
        },
        {
            value: 'RA000660',
            labelcz: 'Public Register',
            labelen: 'Public Register'
        },
        {
            value: 'RA000715',
            labelcz: 'Dubai Multi Commodities Center Public Directory',
            labelen: 'Dubai Multi Commodities Center Public Directory'
        },
        {
            value: 'RA000783',
            labelcz: 'Public Register',
            labelen: 'Public Register'
        },
        {
            value: 'RA000575',
            labelcz: 'Fujairah Free Zone Company Listing',
            labelen: 'Fujairah Free Zone Company Listing'
        },
        {
            value: 'RA000576',
            labelcz: 'Fujairah Chamber of Commerce and Industry: Business Directory',
            labelen: 'Fujairah Chamber of Commerce and Industry: Business Directory'
        },
        {
            value: 'RA000577',
            labelcz: 'Fujairah Department of Industry and Economy',
            labelen: 'Fujairah Department of Industry and Economy'
        },
        {
            value: 'RA000786',
            labelcz: 'Licensing register',
            labelen: 'Licensing register'
        },
        {
            value: 'RA000753',
            labelcz: 'RAK International Corporate Centre Registry',
            labelen: 'RAK International Corporate Centre Registry'
        },
        {
            value: 'RA000578',
            labelcz: 'Ras Al Khaimah Economic Zone',
            labelen: 'Ras Al Khaimah Economic Zone'
        },
        {
            value: 'RA000579',
            labelcz: 'Department of Economic Development',
            labelen: 'Department of Economic Development'
        },
        {
            value: 'RA000580',
            labelcz: 'Hamriyah Free Zone Authority',
            labelen: 'Hamriyah Free Zone Authority'
        },
        {
            value: 'RA000581',
            labelcz: 'Sharjah Chamber of Commerce and Industry: Business Directory',
            labelen: 'Sharjah Chamber of Commerce and Industry: Business Directory'
        },
        {
            value: 'RA000582',
            labelcz: 'Sharjah Airport International Free Zone',
            labelen: 'Sharjah Airport International Free Zone'
        },
        {
            value: 'RA000583',
            labelcz: 'Economic Development Department',
            labelen: 'Economic Development Department'
        },
        {
            value: 'RA000584',
            labelcz: 'Umm Al Quwain Chamber of Commerce and Industry',
            labelen: 'Umm Al Quwain Chamber of Commerce and Industry'
        },
        {
            value: 'RA000752',
            labelcz: 'National Economic Register',
            labelen: 'National Economic Register'
        },
        {
            value: 'RA001029',
            labelcz: 'Dubai Development Authority',
            labelen: 'Dubai Development Authority'
        },
        {
            value: 'RA001030',
            labelcz: 'Dubai Silicon Oasis Authority (DSOA)',
            labelen: 'Dubai Silicon Oasis Authority (DSOA)'
        },
        {
            value: 'RA001031',
            labelcz: 'Fujairah Municipality',
            labelen: 'Fujairah Municipality'
        },
        {
            value: 'RA001028',
            labelcz: 'Securities and Commodities Authority',
            labelen: 'Securities and Commodities Authority'
        },
        {
            value: 'RA001049',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA001063',
            labelcz: 'Federal Tax Authority',
            labelen: 'Federal Tax Authority'
        },
        {
            value: 'RA001077',
            labelcz: 'Company Directory',
            labelen: 'Company Directory'
        },
        {
            value: 'RA001097',
            labelcz: 'Register of licensed companies',
            labelen: 'Register of licensed companies'
        },
        {
            value: 'RA001104',
            labelcz: 'Sharjah Research Technology and Innovation Park Authority (SRTIP)',
            labelen: 'Sharjah Research Technology and Innovation Park Authority (SRTIP)'
        },
        {
            value: 'RA001107',
            labelcz: 'Securities and Commodities Authority',
            labelen: 'Securities and Commodities Authority'
        },
        {
            value: 'RA001119',
            labelcz: 'Business Licensing Services',
            labelen: 'Business Licensing Services'
        },
        {
            value: 'RA001120',
            labelcz: 'Business License Verification',
            labelen: 'Business License Verification'
        }
    ],
    GB: [
        {
            value: 'RA000585',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA000589',
            labelcz: 'Charity Commission for England and Wales',
            labelen: 'Charity Commission for England and Wales'
        },
        {
            value: 'RA000726',
            labelcz: 'Regulated Law Firms',
            labelen: 'Regulated Law Firms'
        },
        {
            value: 'RA000788',
            labelcz: 'The Church of England',
            labelen: 'The Church of England'
        },
        {
            value: 'RA000586',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA000701',
            labelcz: 'Register of Charities',
            labelen: 'Register of Charities'
        },
        {
            value: 'RA000587',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA000590',
            labelcz: 'Scottish Charity Register',
            labelen: 'Scottish Charity Register'
        },
        {
            value: 'RA000588',
            labelcz: 'Mutuals Public Register',
            labelen: 'Mutuals Public Register'
        },
        {
            value: 'RA000591',
            labelcz: 'The Pensions Regulator',
            labelen: 'The Pensions Regulator'
        },
        {
            value: 'RA000592',
            labelcz: 'Financial Services Register',
            labelen: 'Financial Services Register'
        },
        {
            value: 'RA000789',
            labelcz: 'List of Trade Unions',
            labelen: 'List of Trade Unions'
        },
        {
            value: 'RA000790',
            labelcz: 'Register Of Statutory Auditors',
            labelen: 'Register Of Statutory Auditors'
        },
        {
            value: 'RA000791',
            labelcz: 'Register of Learning Providers',
            labelen: 'Register of Learning Providers'
        },
        {
            value: 'RA001032',
            labelcz: 'The Law Society of Northern Ireland',
            labelen: 'The Law Society of Northern Ireland'
        },
        {
            value: 'RA001124',
            labelcz: 'HM Revenue & Customs',
            labelen: 'HM Revenue & Customs'
        }
    ],
    US: [
        {
            value: 'RA000595',
            labelcz: 'Alabama - Government Records',
            labelen: 'Government Records'
        },
        {
            value: 'RA000594',
            labelcz: 'State of Alaska Corporations Registry',
            labelen: 'State of Alaska Corporations Registry'
        },
        {
            value: 'RA000597',
            labelcz: 'Arizona Corporation Commission',
            labelen: 'Arizona Corporation Commission'
        },
        {
            value: 'RA000596',
            labelcz: 'Arkansas - Business & Commercial Services',
            labelen: 'Business & Commercial Services'
        },
        {
            value: 'RA000598',
            labelcz: 'California - Business Entity Records',
            labelen: 'Business Entity Records'
        },
        {
            value: 'RA000599',
            labelcz: 'Colorado - Business Division of the Secretary of State’s office',
            labelen: 'Business Division of the Secretary of State’s office'
        },
        {
            value: 'RA000600',
            labelcz: "Connecticut - Secretary of the State's Commercial Recording Division",
            labelen: "Secretary of the State's Commercial Recording Division"
        },
        {
            value: 'RA000602',
            labelcz: 'Delaware - Division of Corporations, Department of State',
            labelen: 'Division of Corporations, Department of State'
        },
        {
            value: 'RA000601',
            labelcz: 'District of Columbia - Department of Consumer and Regulatory Affairs',
            labelen: 'Department of Consumer and Regulatory Affairs'
        },
        {
            value: 'RA000603',
            labelcz: 'Florida Division of Corporations',
            labelen: 'Florida Division of Corporations'
        },
        {
            value: 'RA000604',
            labelcz: 'Georgia Secretary of State Corporations Division',
            labelen: 'Georgia Secretary of State Corporations Division'
        },
        {
            value: 'RA000605',
            labelcz: 'Hawaii - Business Registration Division (Department of Commerce & Consumer Affairs)',
            labelen: 'Business Registration Division (Department of Commerce & Consumer Affairs)'
        },
        {
            value: 'RA000607',
            labelcz: 'Idaho - Business Services (Secretary of State)',
            labelen: 'Business Services (Secretary of State)'
        },
        {
            value: 'RA000608',
            labelcz: 'Illinois - Business Services (Office of the Secretary of State)',
            labelen: 'Business Services (Office of the Secretary of State)'
        },
        {
            value: 'RA000609',
            labelcz: 'Indiana - Business Services Division (Secretary of State)',
            labelen: 'Business Services Division (Secretary of State)'
        },
        {
            value: 'RA000606',
            labelcz: 'Iowa - Business Services Division (Secretary of State)',
            labelen: 'Business Services Division (Secretary of State)'
        },
        {
            value: 'RA000610',
            labelcz: 'Kansas - Business Center',
            labelen: 'Business Center'
        },
        {
            value: 'RA000611',
            labelcz: 'Kentucky - Business Services (Office of the Secretary of State)',
            labelen: 'Business Services (Office of the Secretary of State)'
        },
        {
            value: 'RA000612',
            labelcz: 'Louisiana - Corporations Section (Office of the Secretary of State)',
            labelen: 'Corporations Section (Office of the Secretary of State)'
        },
        {
            value: 'RA000615',
            labelcz:
                'Maine - Division of Corporations, UCC and Commissions, Bureau of Corporations, Elections & Commissions, Department of the Secretary of State',
            labelen: ''
        },
        {
            value: 'RA000614',
            labelcz: 'Maryland - Business Services (Maryland Department of Assessments and Taxation)',
            labelen: 'Business Services (Maryland Department of Assessments and Taxation)'
        },
        {
            value: 'RA000613',
            labelcz: "Massachusetts - Corporations Division (Secretary of the Commonwealth's Office)",
            labelen: "Corporations Division (Secretary of the Commonwealth's Office)"
        },
        {
            value: 'RA000616',
            labelcz: 'Michigan - Corporations Division (Department of Licensing and Regulatory Affairs)',
            labelen: 'Corporations Division (Department of Licensing and Regulatory Affairs)'
        },
        {
            value: 'RA000617',
            labelcz: 'Minnesota - Office of the Minnesota Secretary of State Business & Lien system',
            labelen: 'Office of the Minnesota Secretary of State Business & Lien system'
        },
        {
            value: 'RA000619',
            labelcz: 'Mississippi - Business Services, Office of the Secretary of State',
            labelen: 'Business Services, Office of the Secretary of State'
        },
        {
            value: 'RA000618',
            labelcz: 'Misouri - Corporations Unit, Business Services (Office of the Secretary of State)',
            labelen: 'Corporations Unit, Business Services (Office of the Secretary of State)'
        },
        {
            value: 'RA000620',
            labelcz: 'Montana - Secretary of State Corporate Records',
            labelen: 'Secretary of State Corporate Records'
        },
        {
            value: 'RA000623',
            labelcz: 'Nebraska - Secretary of State Business Services Division',
            labelen: 'Secretary of State Business Services Division'
        },
        {
            value: 'RA000627',
            labelcz: 'Nevada - Business Center (Secretary of State)',
            labelen: 'Business Center (Secretary of State)'
        },
        {
            value: 'RA000624',
            labelcz: "New Hampshire - Corporation Division (Secretary of State's Office)",
            labelen: "Corporation Division (Secretary of State's Office)"
        },
        {
            value: 'RA000625',
            labelcz: 'New Jersey - Business Records Service (Division of Revenue & Enterprise Services)',
            labelen: 'Business Records Service (Division of Revenue & Enterprise Services)'
        },
        {
            value: 'RA000626',
            labelcz: 'New Mexico - Business Services Center (Office of the Secretary of State)',
            labelen: 'Business Services Center (Office of the Secretary of State)'
        },
        {
            value: 'RA000628',
            labelcz:
                'New York - Corporation and Business Entity Database (Division of Corporations, State Records and UCC, Department of State)',
            labelen:
                'Corporation and Business Entity Database (Division of Corporations, State Records and UCC, Department of State)'
        },
        {
            value: 'RA000747',
            labelcz: 'New York - Registry of insurance companies',
            labelen: 'Registry of insurance companies'
        },
        {
            value: 'RA000621',
            labelcz: 'North Carolina - Corporations Division (Department of the Secretary of State)',
            labelen: 'Corporations Division (Department of the Secretary of State)'
        },
        {
            value: 'RA000622',
            labelcz: "North Dakota - Business Services (Secretary of State's Office)",
            labelen: "Business Services (Secretary of State's Office)"
        },
        {
            value: 'RA000629',
            labelcz: 'Ohio - Corporation Database (Ohio Secretary of State)',
            labelen: 'Corporation Database (Ohio Secretary of State)'
        },
        {
            value: 'RA000630',
            labelcz: 'Oklahoma - Business Filing Department (Oklahoma Secretary of State)',
            labelen: 'Business Filing Department (Oklahoma Secretary of State)'
        },
        {
            value: 'RA000631',
            labelcz: 'Oregon - Corporation Division (Oregon Secretary of State)',
            labelen: 'Corporation Division (Oregon Secretary of State)'
        },
        {
            value: 'RA000632',
            labelcz: 'Pennsylvania Department of State',
            labelen: 'Pennsylvania Department of State'
        },
        {
            value: 'RA000633',
            labelcz: 'Rhode Island - Division Of Business Services (Rhode Island Office of the Secretary of State)',
            labelen: 'Division Of Business Services (Rhode Island Office of the Secretary of State)'
        },
        {
            value: 'RA000634',
            labelcz: 'South Carolina - Business Filings database (South Carolina Secretary of State)',
            labelen: 'Business Filings database (South Carolina Secretary of State)'
        },
        {
            value: 'RA000635',
            labelcz: 'South Dakota - Business Services Division (Office of the Secretary of State)',
            labelen: 'Business Services Division (Office of the Secretary of State)'
        },
        {
            value: 'RA000636',
            labelcz: 'Tennessee - Business Services (Department of State)',
            labelen: 'Business Services (Department of State)'
        },
        {
            value: 'RA000637',
            labelcz: 'Texas - Corporations Section (Texas Secretary of State)',
            labelen: 'Corporations Section (Texas Secretary of State)'
        },
        {
            value: 'RA000751',
            labelcz: 'Texas - Trust Companies registry',
            labelen: 'Trust Companies registry'
        },
        {
            value: 'RA000665',
            labelcz: 'USA - EDGAR',
            labelen: 'EDGAR'
        },
        {
            value: 'RA000744',
            labelcz: 'USA - Registry of FDIC-insured banking institutions',
            labelen: 'Registry of FDIC-insured banking institutions'
        },
        {
            value: 'RA000745',
            labelcz: 'USA - Registry of federally insured credit unions',
            labelen: 'Registry of federally insured credit unions'
        },
        {
            value: 'RA000746',
            labelcz: 'USA - Registry of insurance companies',
            labelen: 'Registry of insurance companies'
        },
        {
            value: 'RA000748',
            labelcz: 'USA - National Information Center (NIC)',
            labelen: 'National Information Center (NIC)'
        },
        {
            value: 'RA000792',
            labelcz: 'USA - Financial Institution Lists',
            labelen: 'Financial Institution Lists'
        },
        {
            value: 'RA000638',
            labelcz: 'Utah Division of Corporations & Commercial Code (Department of Commerce)',
            labelen: 'Utah Division of Corporations & Commercial Code (Department of Commerce)'
        },
        {
            value: 'RA000640',
            labelcz: 'Vermont - Corporations Division (Vermont Secretary of State)',
            labelen: 'Corporations Division (Vermont Secretary of State)'
        },
        {
            value: 'RA000639',
            labelcz: 'Virginia - State Corporation Commission',
            labelen: 'State Corporation Commission'
        },
        {
            value: 'RA000641',
            labelcz: 'Washington - Corporations Division (Office of the Secretary of State)',
            labelen: 'Corporations Division (Office of the Secretary of State)'
        },
        {
            value: 'RA000643',
            labelcz: 'West Virginia - Business and Licensing (West Virginia Secretary of State)',
            labelen: 'Business and Licensing (West Virginia Secretary of State)'
        },
        {
            value: 'RA000642',
            labelcz:
                'Wisconsin - Corporation Section (Division of Corporate & Consumer Services, Department of Financial Institutions)',
            labelen:
                'Corporation Section (Division of Corporate & Consumer Services, Department of Financial Institutions)'
        },
        {
            value: 'RA000644',
            labelcz: 'Wyoming - Business Center (Wyoming Secretary of State)',
            labelen: 'Business Center (Wyoming Secretary of State)'
        },
        {
            value: 'RA001033',
            labelcz: 'Financial Industry Regulatory Authority',
            labelen: 'Financial Industry Regulatory Authority'
        },
        {
            value: 'RA001053',
            labelcz: 'Illinois Department of Agriculture - License List',
            labelen: 'Illinois Department of Agriculture - License List'
        },
        {
            value: 'RA001054',
            labelcz: 'National Futures Association - BASIC',
            labelen: 'National Futures Association - BASIC'
        },
        {
            value: 'RA001066',
            labelcz: 'Database of Accredited Postsecondary Institutions and Programs (DAPIP)',
            labelen: 'Database of Accredited Postsecondary Institutions and Programs (DAPIP)'
        },
        {
            value: 'RA001096',
            labelcz: 'Business Lookup',
            labelen: 'Business Lookup'
        },
        {
            value: 'RA001102',
            labelcz: 'Charities Bureau Registry',
            labelen: 'Charities Bureau Registry'
        },
        {
            value: 'RA001112',
            labelcz: 'List of Texas State-Chartered Credit Unions',
            labelen: 'List of Texas State-Chartered Credit Unions'
        }
    ],
    UY: [
        {
            value: 'RA000645',
            labelcz: 'General Directorate of Registries',
            labelen: 'General Directorate of Registries'
        },
        {
            value: 'RA000690',
            labelcz: 'Registro Único Tributario (RUT)',
            labelen: 'Registro Único Tributario (RUT)'
        },
        {
            value: 'RA001034',
            labelcz: 'Superintendence of Financial Services (Central Bank of Uruguay)',
            labelen: 'Superintendence of Financial Services (Central Bank of Uruguay)'
        }
    ],
    UZ: [
        {
            value: 'RA000646',
            labelcz: 'Register of Associations and Legal Entities',
            labelen: 'Register of Associations and Legal Entities'
        },
        {
            value: 'RA001035',
            labelcz: 'Central Securities Depository',
            labelen: 'Central Securities Depository'
        },
        {
            value: 'RA001036',
            labelcz: 'Central Bank of the Republic of Uzbekistan',
            labelen: 'Central Bank of the Republic of Uzbekistan'
        }
    ],
    VU: [
        {
            value: 'RA000647',
            labelcz: 'Companies Registry',
            labelen: 'Companies Registry'
        }
    ],
    VE: [
        {
            value: 'RA000648',
            labelcz: 'National System Register of Enterprises and Business',
            labelen: 'National System Register of Enterprises and Business'
        },
        {
            value: 'RA001037',
            labelcz: 'Superintendencia Nacional de Valores',
            labelen: 'Superintendencia Nacional de Valores'
        },
        {
            value: 'RA001038',
            labelcz: 'Superintendencia de las Instituciones del Sector Bancario',
            labelen: 'Superintendencia de las Instituciones del Sector Bancario'
        },
        {
            value: 'RA001056',
            labelcz: 'Registro Mercantil',
            labelen: 'Registro Mercantil'
        },
        {
            value: 'RA001057',
            labelcz: 'El Servicio Nacional Integrado de Administración Aduanera y Tributaria (SENIAT)',
            labelen: 'El Servicio Nacional Integrado de Administración Aduanera y Tributaria (SENIAT)'
        },
        {
            value: 'RA001100',
            labelcz: 'Registro de Identificación Fiscal',
            labelen: 'Registro de Identificación Fiscal'
        }
    ],
    VN: [
        {
            value: 'RA000649',
            labelcz: 'Business Registration',
            labelen: 'Business Registration'
        },
        {
            value: 'RA001039',
            labelcz: 'State Securities Commission of Vietnam',
            labelen: 'State Securities Commission of Vietnam'
        }
    ],
    WF: [
        {
            value: 'RA000189',
            labelcz: 'Register of Companies (Sirene)',
            labelen: 'Register of Companies (Sirene)'
        },
        {
            value: 'RA000192',
            labelcz: 'Register of Commerce and Companies',
            labelen: 'Register of Commerce and Companies'
        },
        {
            value: 'RA000650',
            labelcz: 'RA000650',
            labelen: 'RA000650'
        }
    ],
    YE: [
        {
            value: 'RA000651',
            labelcz: 'Ministry of Industry and Trade',
            labelen: 'Ministry of Industry and Trade'
        },
        {
            value: 'RA001040',
            labelcz: 'Centeral Bank Of Yemen',
            labelen: 'Centeral Bank Of Yemen'
        }
    ],
    ZM: [
        {
            value: 'RA000652',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA001041',
            labelcz: 'Bank of Zambia',
            labelen: 'Bank of Zambia'
        },
        {
            value: 'RA001042',
            labelcz: 'Securities & Exchange Commission',
            labelen: 'Securities & Exchange Commission'
        }
    ],
    ZW: [
        {
            value: 'RA000653',
            labelcz: 'Companies Register',
            labelen: 'Companies Register'
        },
        {
            value: 'RA001043',
            labelcz: 'Reserve Bank of Zimbabwe',
            labelen: 'Reserve Bank of Zimbabwe'
        },
        {
            value: 'RA001044',
            labelcz: 'Securities and Exchange Commission of Zimbabwe (SECZ)',
            labelen: 'Securities and Exchange Commission of Zimbabwe (SECZ)'
        }
    ],
    TK: [
        {
            value: 'RA000964',
            labelcz: 'Financial Markets Authority New Zealand',
            labelen: 'Financial Markets Authority New Zealand'
        }
    ],
    SY: [
        {
            value: 'RA001008',
            labelcz: 'Syrian Commission on Financial Markets and Securities',
            labelen: 'Syrian Commission on Financial Markets and Securities'
        }
    ],
    SH: [
        {
            value: 'RA000988',
            labelcz: 'Financial Services Regulatory Authority (FSRA)',
            labelen: 'Financial Services Regulatory Authority (FSRA)'
        }
    ],
    LY: [
        {
            value: 'RA000936',
            labelcz: 'Central Bank of Libya',
            labelen: 'Central Bank of Libya'
        },
        {
            value: 'RA000937',
            labelcz: 'Libyan Capital Market Authority',
            labelen: 'Libyan Capital Market Authority'
        }
    ],
    KM: [
        {
            value: 'RA000849',
            labelcz: 'Banque Centrale des Comores',
            labelen: 'Banque Centrale des Comores'
        }
    ],
    GQ: [
        {
            value: 'RA000829',
            labelcz: 'Bank of Central African States (BEAC)',
            labelen: 'Bank of Central African States (BEAC)'
        }
    ],
    GW: [
        {
            value: 'RA000814',
            labelcz: 'Central Bank of West African States (BCEAO)',
            labelen: 'Central Bank of West African States (BCEAO)'
        }
    ],
    VA: [
        {
            value: 'RA000891',
            labelcz: 'The Supervisory and Financial Information Authority',
            labelen: 'The Supervisory and Financial Information Authority'
        }
    ]
};
